import * as React from "react";
import { FontIcon } from "@fluentui/react/lib/Icon";
import headerWebSite1 from "../images/bridg/header-bg-1.jpg";
import headerWebSite2 from "../images/bridg/header-bg-2.jpg";
import headerWebSite3 from "../images/bridg/header-bg-3.jpg";
import headerWebSite4 from "../images/bridg/header-bg-4.jpg";
import headerWebSite5 from "../images/bridg/header-bg-5.jpg";
import headerWebSite6 from "../images/bridg/header-bg-6.jpg";
import headerWebSite7 from "../images/bridg/header-bg-7.jpg";
import headerWebSite8 from "../images/bridg/header-bg-8.jpg";

export const enum__PRIVILEGE_APP = {
  KPI: "KPI",
  EDP: "EDP",
  CO: "CO",
  BOOK: "BOOK",
  BASE: "BASE",
};
export const __PrivilegeApp = [
  { key: enum__PRIVILEGE_APP.KPI, value: "data-lang-lbl-kpi" },
  { key: enum__PRIVILEGE_APP.EDP, value: "data-lang-lbl-edp" },
  { key: enum__PRIVILEGE_APP.CO, value: "data-lang-lbl-co" },
  { key: enum__PRIVILEGE_APP.BOOK, value: "data-lang-product-book" },
];

///////////Transversal///////////

export const __enum_SystemBulkUpload = {
  Select: 0,
  Book: 1,
  Kpi: 2,
  Partidas: 2,
};

export const __SystemBulkUpload = [
  {
    keyTypeUniqueId: enum__PRIVILEGE_APP.KPI,
    key: __enum_SystemBulkUpload.Kpi,
    enabledOnlyWithElementIdAvailable: false,
    checked: true,
    version: "v1.0",
    code: "TMPKPI",
    name: "data-lang-lbl-kpi",
    description: "data-lang-lbl-bulkupload-kpi-description",
    disable: false,
  },
  {
    keyTypeUniqueId: enum__PRIVILEGE_APP.EDP,
    key: __enum_SystemBulkUpload.Partidas,
    enabledOnlyWithElementIdAvailable: true,
    checked: true,
    version: "v1.0",
    code: "TMPPARTIDAS",
    name: "data-lang-lbl-parties",
    description: "data-lang-lbl-bulkupload-parties-description",
    disable: false,
  },
  {
    keyTypeUniqueId: enum__PRIVILEGE_APP.BOOK,
    key: __enum_SystemBulkUpload.Book,
    enabledOnlyWithElementIdAvailable: false,
    checked: true,
    version: "v1.0",
    code: "TMPBOOK",
    name: "data-lang-lbl-book",
    description: "data-lang-lbl-bulkupload-book-description",
    disable: false,
  },
];

//Orden del arreglo de enumerable debe ser el mismo que el del diccionario __SystemPagesPaths.
export const customCalendarStrings = {
  closeButtonAriaLabel: "data-lang-lbl-close",
  dayMarkedAriaLabel: "data-lang-lbl-marked",
  days: [
    "data-lang-lbl-calendar-days-sunday",
    "data-lang-lbl-calendar-days-monday",
    "data-lang-lbl-calendar-days-tuesday",
    "data-lang-lbl-calendar-days-wednesday",
    "data-lang-lbl-calendar-days-thursday",
    "data-lang-lbl-calendar-days-friday",
    "data-lang-lbl-calendar-days-saturday",
  ],
  goToToday: "data-lang-lbl-calendar-gototoday",
  monthPickerHeaderAriaLabel: "data-lang-lbl-calendar-changeyear",
  months: [
    "data-lang-lbl-calendar-month-january",
    "data-lang-lbl-calendar-month-february",
    "data-lang-lbl-calendar-month-march",
    "data-lang-lbl-calendar-month-april",
    "data-lang-lbl-calendar-month-may",
    "data-lang-lbl-calendar-month-june",
    "data-lang-lbl-calendar-month-july",
    "data-lang-lbl-calendar-month-august",
    "data-lang-lbl-calendar-month-september",
    "data-lang-lbl-calendar-month-october",
    "data-lang-lbl-calendar-month-november",
    "data-lang-lbl-calendar-month-december",
  ],
  nextMonthAriaLabel: "data-lang-lbl-calendar-nextmonth",
  nextYearAriaLabel: "data-lang-lbl-calendar-nextyear",
  nextYearRangeAriaLabel: "data-lang-lbl-calendar-nextyearrange",
  prevMonthAriaLabel: "data-lang-lbl-calendar-previousmonth",
  prevYearAriaLabel: "data-lang-lbl-calendar-previousyear",
  prevYearRangeAriaLabel: "data-lang-lbl-calendar-previousyearrange",
  selectedDateFormatString: "data-lang-lbl-calendar-selecteddate",
  shortDays: [
    "data-lang-lbl-calendar-shortdays-sunday",
    "data-lang-lbl-calendar-shortdays-monday",
    "data-lang-lbl-calendar-shortdays-tuesday",
    "data-lang-lbl-calendar-shortdays-wednesday",
    "data-lang-lbl-calendar-shortdays-thursday",
    "data-lang-lbl-calendar-shortdays-friday",
    "data-lang-lbl-calendar-shortdays-saturday",
  ],
  shortMonths: [
    "data-lang-lbl-calendar-shortmonth-january",
    "data-lang-lbl-calendar-shortmonth-february",
    "data-lang-lbl-calendar-shortmonth-march",
    "data-lang-lbl-calendar-shortmonth-april",
    "data-lang-lbl-calendar-shortmonth-may",
    "data-lang-lbl-calendar-shortmonth-june",
    "data-lang-lbl-calendar-shortmonth-july",
    "data-lang-lbl-calendar-shortmonth-august",
    "data-lang-lbl-calendar-shortmonth-september",
    "data-lang-lbl-calendar-shortmonth-october",
    "data-lang-lbl-calendar-shortmonth-november",
    "data-lang-lbl-calendar-shortmonth-december",
  ],
  todayDateFormatString: "data-lang-lbl-calendar-todaysdate",
  weekNumberFormatString: "data-lang-lbl-calendar-weeknumber",
  yearPickerHeaderAriaLabel: "data-lang-lbl-calendar-changemonth",
};

export const __enum_TeachBoardConfig = [
  "data-lang-msg-teach-boardconfig-1",
  "data-lang-msg-teach-boardconfig-2",
  "data-lang-msg-teach-boardconfig-3",
  "data-lang-msg-teach-boardconfig-4",
  "data-lang-msg-teach-boardconfig-5",
];

export const __enum_TeachBulkUpload = [
  "data-lang-msg-teach-bulkupload-1",
  "data-lang-msg-teach-bulkupload-2",
  "data-lang-msg-teach-bulkupload-3",
  "data-lang-msg-teach-bulkupload-4",
];

export const __enum_TeachGapPage = [
  "data-lang-msg-teach-gappage-1",
  "data-lang-msg-teach-gappage-2",
  "data-lang-msg-teach-gappage-3",
  "data-lang-msg-teach-gappage-4",
  "data-lang-msg-teach-gappage-5",
  "data-lang-msg-teach-gappage-6",
  "data-lang-msg-teach-gappage-7",
  "data-lang-msg-teach-gappage-8",
];

export const __enum_SystemPages = {
  HomeBook: 0,
  BookCreation: 1,
  Book: 2,
  BookV2: 3,
  BookV3: 4,
  HomeKPI: 5,
  Board: 6,
  BoardCreation: 7,
  ElementConfiguration: 8,
  Gap: 9,
  MeasurementUnit: 10,
  MasterKpi: 11,
  TypeOf: 12,
  Variable: 13,
  HomeLanding: 14,
  Login: 15,
  Logout: 16,
  Contract: 17,
  Project: 18,
  BusinessUnit: 19,
  LegalEntity: 20,
  Maintenance: 21,
  Logoutt: 22,
  HomeKPIV2: 23,
  ConfigurationReport: 24,
  ConfigurationBoard: 25,
  Privilege: 26,
  GapV2: 27,
  BoardV2: 28,
  BulkUpload: 29,

  BoardLanding: 30,
  BoardPortfolio: 31,
  BoardBusiness: 32,
  BoardEDP: 33,
  BoardReport: 34,
  Ticket: 35,
  Roles: 36,
  ContractModification: 37,
  Integration: 38,
  HomeLandingV2: 39,

  ContactParties: 40,
  Adjustments: 41,
  ConfigureEdP: 42,
  PrepareEdP: 43,

  ContractCompare: 44,

  Increment: 45,
  Deduction: 46,

  PartieType: 47,
  PartieUnit: 48,
  PolinomyType: 49,

  NotificationTasks: 50,
  Currency: 51,
  DocumentTeach: 52,
  BoardLandingExternal: 53,
  Health: 54,
  PowerBI: 55,
  Obligation: 56,
  ObligationCategory: 57,
  ElementObligations: 58,
  HomeObligations: 59,

  PowerBIReport: 60,
  DitributionGroups: 61,
  NoDataAccess: 62,
  JobPosition: 63,
  MessageTopic: 64,
  ChecklistNotaTipo: 65,
  ObligationInconsistency: 66
};

export const __BoardIdTemplateStatic = {
  KPI: 5,
  BOARD: 6,
};

export const __enum_PageMode = {
  View: 0,
  Edit: 1,
  None: -1,
};
//Orden del arreglo de diccionario debe ser el mismo que el del enumerable __enum_SystemPages.
export const __SystemPagesPaths = [
  {
    key: __enum_SystemPages.HomeBook,
    text: "/BookHome",
    siteName: "data-lang-site-book-name",
    key2: "bookhome",
    value: "data-lang-pagename-bookhome",
  },
  {
    key: __enum_SystemPages.BookCreation,
    text: "/Book/BookCreation",
    siteName: "data-lang-site-book-name",
    key2: "book/bookcreation",
    value: "data-lang-pagename-bookcreation",
  },
  {
    key: __enum_SystemPages.Book,
    text: "/Book/Book",
    siteName: "data-lang-site-book-name",
    key2: "book/book",
    value: "data-lang-pagename-book",
  },
  {
    key: __enum_SystemPages.BookV2,
    text: "/Book/BookMessages",
    siteName: "data-lang-site-book-name",
    key2: "book/bookmessages",
    value: "data-lang-pagename-book",
  },
  {
    key: __enum_SystemPages.BookV3,
    text: "/Book/Messages",
    siteName: "data-lang-site-book-name",
    key2: "book/messages",
    value: "data-lang-pagename-book",
  },
  {
    key: __enum_SystemPages.HomeKPI,
    text: "/KPIHome",
    siteName: "data-lang-site-kpi-name",
    key2: "kpihome",
    value: "data-lang-pagename-kpihome",
  },
  {
    key: __enum_SystemPages.Board,
    text: "/Board",
    siteName: "",
    key2: "board",
    value: "",
  },
  {
    key: __enum_SystemPages.BoardCreation,
    text: "/Kpi/BoardCreation",
    siteName: "data-lang-site-kpi-name",
    key2: "kpi/boardcreation",
    value: "data-lang-pagename-boardcreation",
  },
  {
    key: __enum_SystemPages.ElementConfiguration,
    text: "/Kpi/ElementConfiguration",
    siteName: "data-lang-site-kpi-name",
    key2: "kpi/elementconfiguration",
    value: "data-lang-pagename-elementconfiguration",
  },
  {
    key: __enum_SystemPages.Gap,
    text: "/Kpi/Gap",
    siteName: "data-lang-site-kpi-name",
    key2: "kpi/gap",
    value: "data-lang-pagename-gap",
  },
  {
    key: __enum_SystemPages.MeasurementUnit,
    text: "/forms/measurementUnit",
    siteName: "data-lang-pagename-maintainers",
    key2: "forms/measurementunit",
    value: "data-lang-pagename-measurementunit",
  },
  {
    key: __enum_SystemPages.MasterKpi,
    text: "/forms/masterKpi",
    siteName: "data-lang-pagename-maintainers",
    key2: "forms/masterkpi",
    value: "data-lang-pagename-masterkpi",
  },
  {
    key: __enum_SystemPages.TypeOf,
    text: "/forms/typeOf",
    siteName: "data-lang-pagename-maintainers",
    key2: "forms/typeof",
    value: "data-lang-pagename-typeof",
  },
  {
    key: __enum_SystemPages.Variable,
    text: "/forms/variable",
    siteName: "data-lang-pagename-maintainers",
    key2: "forms/variable",
    value: "data-lang-pagename-variable",
  },
  {
    key: __enum_SystemPages.HomeLanding,
    text: "/OldHome",
    siteName: "data-lang-site-book-name",
    key2: "home",
    value: "data-lang-pagename-home",
  },
  {
    key: __enum_SystemPages.Login,
    text: "/Login",
    siteName: "",
    key2: "",
    value: "",
  },
  {
    key: __enum_SystemPages.Logout,
    text: "/Logout",
    siteName: "",
    key2: "",
    value: "",
  },
  {
    key: __enum_SystemPages.Contract,
    text: "/forms/contract",
    siteName: "data-lang-pagename-maintainers",
    key2: "forms/contract",
    value: "data-lang-pagename-contracts",
  },
  {
    key: __enum_SystemPages.Project,
    text: "/forms/project",
    siteName: "data-lang-pagename-maintainers",
    key2: "forms/project",
    value: "data-lang-pagename-projects",
  },
  {
    key: __enum_SystemPages.BusinessUnit,
    text: "/forms/businessunit",
    siteName: "data-lang-pagename-maintainers",
    key2: "forms/businessunit",
    value: "data-lang-pagename-businessunit",
  },
  {
    key: __enum_SystemPages.LegalEntity,
    text: "/forms/legalentity",
    siteName: "data-lang-pagename-maintainers",
    key2: "forms/legalentity",
    value: "data-lang-pagename-legalentity",
  },
  {
    key: __enum_SystemPages.Maintenance,
    text: "/Maintenance",
    siteName: "",
    key2: "",
    value: "",
  },
  {
    key: __enum_SystemPages.Logoutt,
    text: "/Logoutt",
    siteName: "",
    key2: "",
    value: "",
  },
  {
    key: __enum_SystemPages.HomeKPIV2,
    text: "/KPIHomeV2",
    siteName: "",
    key2: "kpihomev2",
    value: "data-lang-pagename-kpihomev2",
  },
  {
    key: __enum_SystemPages.ConfigurationReport,
    text: "/Kpi/Configuration/Report",
    siteName: "data-lang-site-kpi-name",
    key2: "kpi/configuration/report",
    value: "data-lang-pagename-reportconfiguration",
  },
  {
    key: __enum_SystemPages.ConfigurationBoard,
    text: "/Kpi/Configuration/Board",
    siteName: "data-lang-site-kpi-name",
    key2: "kpi/configuration/board",
    value: "data-lang-pagename-boardconfiguration",
  },
  {
    key: __enum_SystemPages.Privilege,
    text: "/forms/privilege",
    siteName: "data-lang-pagename-maintainers",
    key2: "forms/privilege",
    value: "data-lang-pagename-privilege",
  },
  {
    key: __enum_SystemPages.GapV2,
    text: "/Kpi/GapV2",
    siteName: "",
    key2: "kpi/gapv2",
    value: "data-lang-pagename-gap",
  },
  {
    key: __enum_SystemPages.BoardV2,
    text: "/Kpi/BoardV2",
    siteName: "",
    key2: "kpi/boardv2",
    value: "data-lang-pagename-board",
  },
  {
    key: __enum_SystemPages.BulkUpload,
    text: "/Kpi/BulkUpload",
    siteName: "",
    key2: "kpi/bulkupload",
    value: "data-lang-pagename-bulkupload",
  },
  {
    key: __enum_SystemPages.BoardLanding,
    text: "/",
    siteName: "",
    key2: "landing",
    value: "data-lang-pagename-boardhome",
  },
  {
    key: __enum_SystemPages.BoardPortfolio,
    text: "/Portfolio",
    siteName: "",
    key2: "portfolio",
    value: "data-lang-pagename-boardcarteras",
  },
  {
    key: __enum_SystemPages.BoardBusiness,
    text: "/Business",
    siteName: "",
    key2: "business",
    value: "data-lang-pagename-boardcontract",
  },
  {
    key: __enum_SystemPages.BoardEDP,
    text: "/EDP",
    siteName: "",
    key2: "edp",
    value: "data-lang-pagename-boardep",
  },
  {
    key: __enum_SystemPages.BoardReport,
    text: "/Report",
    siteName: "",
    key2: "report",
    value: "data-lang-pagename-boardreport",
  },
  {
    key: __enum_SystemPages.Ticket,
    text: "/Ticket",
    siteName: "",
    key2: "ticket",
    value: "data-lang-pagename-tickethome",
  },
  {
    key: __enum_SystemPages.Roles,
    text: "/Roles",
    siteName: "",
    key2: "roles",
    value: "data-lang-pagename-roleshome",
  },
  {
    key: __enum_SystemPages.ContractModification,
    text: "/forms/ContractModification",
    siteName: "data-lang-pagename-maintainers",
    key2: "forms/contractmodification",
    value: "data-lang-pagename-contractmodification",
  },
  {
    key: __enum_SystemPages.Integration,
    text: "/Integration",
    siteName: "data-lang-pagename-integration",
    key2: "integration",
    value: "data-lang-pagename-integration",
  },
  {
    key: __enum_SystemPages.HomeLandingV2,
    text: "/LandingExperiment",
    siteName: "data-lang-site-name",
    key2: "home",
    value: "data-lang-pagename-home",
  },
  {
    key: __enum_SystemPages.ContactParties,
    text: "/ContactParties",
    siteName: "",
    key2: "ContactParties",
    value: "data-lang-pagename-contactparties",
  },
  {
    key: __enum_SystemPages.Adjustments,
    text: "/Adjustments",
    siteName: "",
    key2: "Adjustments",
    value: "data-lang-pagename-adjustments",
  },
  {
    key: __enum_SystemPages.ConfigureEdP,
    text: "/ConfigureEdP",
    siteName: "",
    key2: "ConfigureEdP",
    value: "data-lang-pagename-configureedp",
  },
  {
    key: __enum_SystemPages.PrepareEdP,
    text: "/PrepareEdP",
    siteName: "",
    key2: "PrepareEdP",
    value: "data-lang-pagename-prepareedp",
  },
  {
    key: __enum_SystemPages.ContractCompare,
    text: "/ContractCompare",
    siteName: "",
    key2: "ContractCompare",
    value: "data-lang-pagename-contractcompare",
  },
  {
    key: __enum_SystemPages.Increment,
    text: "/forms/increment",
    siteName: "data-lang-pagename-maintainers",
    key2: "forms/increment",
    value: "data-lang-pagename-increments",
  },
  {
    key: __enum_SystemPages.Deduction,
    text: "/forms/deduction",
    siteName: "data-lang-pagename-maintainers",
    key2: "forms/deduction",
    value: "data-lang-pagename-deductions",
  },
  {
    key: __enum_SystemPages.PartieType,
    text: "/forms/partietype",
    siteName: "data-lang-pagename-maintainers",
    key2: "forms/partietype",
    value: "data-lang-pagename-partietype",
  },
  {
    key: __enum_SystemPages.PartieUnit,
    text: "/forms/partieunit",
    siteName: "data-lang-pagename-maintainers",
    key2: "forms/partieunit",
    value: "data-lang-pagename-partieunit",
  },
  {
    key: __enum_SystemPages.PolinomyType,
    text: "/forms/polinomytype",
    siteName: "data-lang-pagename-maintainers",
    key2: "forms/polinomytype",
    value: "data-lang-pagename-polinomytype",
  },
  {
    key: __enum_SystemPages.NotificationTasks,
    text: "/notificationtasks",
    siteName: "",
    key2: "NotificationTasks",
    value: "data-lang-pagename-notificationtasks",
  },
  {
    key: __enum_SystemPages.Currency,
    text: "/forms/currency",
    siteName: "data-lang-pagename-maintainers",
    key2: "forms/currency",
    value: "data-lang-pagename-currency",
  },
  {
    key: __enum_SystemPages.DocumentTeach,
    text: "/DocumentTeach",
    siteName: "",
    key2: "DocumentTeach",
    value: "data-lang-pagename-documentteach",
  },
  {
    key: __enum_SystemPages.BoardLandingExternal,
    text: "/",
    siteName: "",
    key2: "landing",
    value: "data-lang-pagename-boardhome",
  },
  {
    key: __enum_SystemPages.Health,
    text: "/Health",
    siteName: "",
    key2: "Health",
    value: "data-lang-pagename-health",
  },
  {
    key: __enum_SystemPages.PowerBI,
    text: "/ContractReport",
    siteName: "",
    key2: "ContractReport",
    value: "data-lang-pagename-powerbi",
  },
  {
    key: __enum_SystemPages.Obligation,
    text: "/forms/obligation",
    siteName: "data-lang-pagename-maintainers",
    key2: "forms/obligation",
    value: "data-lang-pagename-obligations",
  },
  {
    key: __enum_SystemPages.ObligationCategory,
    text: "/forms/obligationcategory",
    siteName: "data-lang-pagename-maintainers",
    key2: "forms/obligationcategory",
    value: "data-lang-pagename-obligationcategory",
  },
  {
    key: __enum_SystemPages.ElementObligations,
    text: "/ElementObligations",
    siteName: "",
    key2: "ElementObligations",
    value: "data-lang-pagename-elementobligations",
  },
  {
    key: __enum_SystemPages.HomeObligations,
    text: "/HomeObligations",
    siteName: "",
    key2: "HomeObligations",
    value: "data-lang-pagename-obligations",
  },
  {
    key: __enum_SystemPages.PowerBIReport,
    text: "/PowerBI",
    siteName: "",
    key2: "PowerBI",
    value: "data-lang-pagename-powerbi",
  },
  {
    key: __enum_SystemPages.DitributionGroups,
    text: "/forms/DitributionGroups",
    siteName: "",
    key2: "forms/DitributionGroups",
    value: "data-lang-pagename-ditributiongroups",
  },
  {
    key: __enum_SystemPages.NoDataAccess,
    text: "/NoDataAccess",
    siteName: "",
    key2: "NoDataAccess",
    value: "data-lang-pagename-nodataaccess",
  },
  {
    key: __enum_SystemPages.JobPosition,
    text: "/forms/jobposition",
    siteName: "data-lang-pagename-maintainers",
    key2: "forms/jobposition",
    value: "data-lang-pagename-jobposition",
  },
  {
    key: __enum_SystemPages.MessageTopic,
    text: "/forms/messagetopic",
    siteName: "",
    key2: "forms/messagetopic",
    value: "data-lang-pagename-messagetopic",
  },
  {
    key: __enum_SystemPages.ChecklistNotaTipo,
    text: "/forms/checklistnotatipo",
    siteName: "data-lang-pagename-maintainers",
    key2: "forms/checklistnotatipo",
    value: "Tipos de nota checklist EdP",
  },
  {
    key: __enum_SystemPages.ObligationInconsistency,
    text: "/forms/obligationinconsistency",
    siteName: "data-lang-pagename-maintainers",
    key2: "forms/obligationinconsistency",
    value: "data-lang-pagename-obligationinconsistency",
  },
];

export const enum__CONTRACT_STATUS = {
  NONE: 0,
  ADJUDICADO: 1,
  VIGENTE: 2,
  TERMINADO: 3,
  FINIQUITADO: 4,
};
export const __CONTRACT_STATUS = [
  {
    key: enum__CONTRACT_STATUS.NONE,
    value: "data-lang-business-contractStatus-0",
  },
  {
    key: enum__CONTRACT_STATUS.ADJUDICADO,
    value: "data-lang-business-contractStatus-1",
  },
  {
    key: enum__CONTRACT_STATUS.VIGENTE,
    value: "data-lang-business-contractStatus-2",
  },
  {
    key: enum__CONTRACT_STATUS.TERMINADO,
    value: "data-lang-business-contractStatus-3",
  },
  {
    key: enum__CONTRACT_STATUS.FINIQUITADO,
    value: "data-lang-business-contractStatus-4",
  },
];

export const __LegalEntityTypeNemo = {
  PROVEEDOR: { Id: 3, Nemo: "A03", Code: "LETPROVE" },
};

export const __ReportTypes = {
  MAIN_SITEUSE: "SiteUse",
  BK_BOOKPARTYS: "BooksSectionParty",
  BK_BOOKUSERS: "UserBooksSectionParty",
  BK_COMMUNICATIONS: "Communications",
  BK_PENDINGCOMMUNICATIONS: "PendingCommunications",
  BK_MILESTONES: "BookMilestones",

  KPI_SITEKPIS: "SiteKpis",
  KPI_SITEKPICONFIGURATIONS: "SiteKpiConfigurations",
  KPI_SITEKPIACTIONS: "SiteKpiActions",
  KPI_CONTRACTROLES: "ContractKpiRoles",
  KPI_GAPREVSITIONACTIONS: "GapRevisionActions",
  KPI_GAPANALYZEACTIONS: "GapAnalyzeActions",
  KPI_GAPANALYZECOMMENTS: "GapAnalyzeComments",
  KPI_ADMINISTRATIVETASKS: "AdministrativeTasks",

  EDP_CONTRACTS: "EdPContracts",
  EDP_CONFIGCONSOLIDATEDGROUP: "EdpConfigConsolidatedGroup",
  EDP_RESULTCONSOLIDATEDGROUP: "EdpResultConsolidatedGroup",
  EDP_SITEEDPS: "SiteEdps",
  CO_SITEOBLIGATIONACHIEVEMENTS: "SiteObligationsAchievements",
  CO_SITEOBLIGATIONS: "SiteObligations",
};

//Deben ser números primos para que sean unicos y sus sumas también. De esa forma se puede saber concretamente que productos posee el cliente.

export const __ListViewMode = { All: 1, Specific: 2 };

export const __DocumentTypeKeys = {
  xls: (
    <FontIcon
      iconName="ExcelDocument"
      className="document-icon document-icon-xls mt-2 pt-1"
    />
  ),
  ppt: (
    <FontIcon
      iconName="PowerPointDocument"
      className="document-icon document-icon-ppt mt-2 pt-1"
    />
  ),
  doc: (
    <FontIcon
      iconName="WordDocument"
      className="document-icon document-icon-doc mt-2 pt-1"
    />
  ),
  pdf: (
    <FontIcon
      iconName="PDF"
      className="document-icon document-icon-pdf mt-2 pt-1"
    />
  ),
  mpp: (
    <FontIcon
      iconName="ProjectDocument"
      className="document-icon document-icon-mpp mt-2 pt-1"
    />
  ),
  none: (
    <FontIcon
      iconName="TextDocument"
      className="document-icon document-icon-none mt-2 pt-1"
    />
  ),
};

export const enum__SIMPLEYESNO = {
  YES: 1,
  NO: 0,
};
export const __SimpleYesNo = [
  { key: enum__SIMPLEYESNO.YES, value: "data-lang-lbl-yes" },
  { key: enum__SIMPLEYESNO.NO, value: "data-lang-lbl-no" },
];

export const enum__TimeScale = {
  DAYS: 0,
  MONTHS: 1,
  YEARS: 2,
};
export const __TimeScale = [
  { key: enum__TimeScale.DAYS, value: "data-lang-lbl-days" },
  { key: enum__TimeScale.MONTHS, value: "data-lang-lbl-months" },
  { key: enum__TimeScale.YEARS, value: "data-lang-lbl-years" },
];

// «Día de vencimiento» de una obligación mensual. En la base son dos marcas: SAME_WEEKDAY = respertarUbicacionReferencia,
// LAST_DAY_OF_MONTH = ultimoDiaMes (manda sobre la otra); SAME_DAY_NUMBER = ninguna de las dos.
export const enum__DueDayRule = {
  SAME_DAY_NUMBER: 0,
  SAME_WEEKDAY: 1,
  LAST_DAY_OF_MONTH: 2,
};
export const __DueDayRule = [
  { key: enum__DueDayRule.SAME_DAY_NUMBER, value: "data-lang-lbl-duedayrule-samedaynumber", example: "data-lang-lbl-duedayrule-samedaynumber-example" },
  { key: enum__DueDayRule.SAME_WEEKDAY, value: "data-lang-lbl-duedayrule-sameweekday", example: "data-lang-lbl-duedayrule-sameweekday-example" },
  { key: enum__DueDayRule.LAST_DAY_OF_MONTH, value: "data-lang-lbl-duedayrule-lastday", example: "data-lang-lbl-duedayrule-lastday-example" },
];

export const enum__DEACTIVATE = {
  YES: true,
  NO: false,
};
export const __Deactivate = [
  { key: enum__DEACTIVATE.YES, value: "data-lang-lbl-yes" },
  { key: enum__DEACTIVATE.NO, value: "data-lang-lbl-no" },
];

export const enum__PRIVILEGES = {
  EDP_PARTIDAS: "PVACT13",
  EDP_CONFIG: "PVACT14",
  EDP_PREPARAR: "PVACT15",
  EDP_VALIDAR: "PVACT16",
  EDP_APROBAR: "PVACT17",

  KPI_CONTRACT_CREATE: "PVACT1",
  KPI_CONTRACT_VALIDATE: "PVACT2",
  KPI_CONTRACT_CLOSE: "PVACT8",
  KPI_CONTRACT_GROUP: "PVACT18",

  GAP_CONTRACT_ANALYZE: "PVACT4",
  GAP_CONTRACT_PROPOSE: "PVACT5",
  GAP_CONTRACT_APROVE: "PVACT3",
  GAP_CONTRACT_EJECUTE: "PVACT6",
  GAP_CONTRACT_DECLARE: "PVACT7",

  BOOK_CONFIG: "CFG",
  BOOK_APPROVE: "APB",
  BOOK_CREATE: "CRD",
  BOOK_READ: "RED",
};
export const __Privileges = [
  {
    code: enum__PRIVILEGES.KPI_CONTRACT_CREATE,
    value: "data-lang-lbl-privilege-create",
  },
  {
    code: enum__PRIVILEGES.KPI_CONTRACT_VALIDATE,
    value: "data-lang-lbl-privilege-validate",
  },
  {
    code: enum__PRIVILEGES.GAP_CONTRACT_APROVE,
    value: "data-lang-lbl-privilege-aprove",
  },
  {
    code: enum__PRIVILEGES.GAP_CONTRACT_ANALYZE,
    value: "data-lang-lbl-privilege-analyze",
  },
  {
    code: enum__PRIVILEGES.GAP_CONTRACT_PROPOSE,
    value: "data-lang-lbl-privilege-propose",
  },
  {
    code: enum__PRIVILEGES.GAP_CONTRACT_EJECUTE,
    value: "data-lang-lbl-privilege-ejecute",
  },
  {
    code: enum__PRIVILEGES.GAP_CONTRACT_DECLARE,
    value: "data-lang-lbl-privilege-declare",
  },
  {
    code: enum__PRIVILEGES.KPI_CONTRACT_CLOSE,
    value: "data-lang-lbl-privilege-close",
  },
];

export const enum__BUTTONKEYS_KPI = {
  PROCESS_GAP: "processgap",
  PROCESS_GAP_REVISION: "processgaprevision",
  PROCESS_GAP_CAUSES: "processgapcauses",
  SELECT_GAP_FISHBONE: "selectgapfishbone",

  CREATE_BOARD: "createboard",
  MOVE_BOARD_ZONES: "dragdropboxes",

  VIEW_BOARD_DATASERIEVALUE: "viewVariableValue",
  ADD_BOARD_DATASERIEVALUE: "addVariableValue",
  ADD_BOARD_DATASERIEVALUE_DOCUMENT: "",
  ADD_BOARD_CONSOLIDATION_GROUP: "addconsolidatebox",
  ADD_GAP_REVISION: "",
  GRUD_GAP_GENERAL_COMMENTS: "crud_generalcommitment",
  GRUD_GAP_ACTIONS: "crud_actions",

  EDIT_BOARD: "",
  EDIT_BOARD_CONTAINER_TITLES: "",
  EDIT_BOARD_DATASERIEVALUE: "editVariableValue",
  EDIT_BOARD_DATASERIE_INFO: "viewDataserieInfo",
  CLOSE_BOARD_DATASERIE: "closeDataserie",
  DELETE_BOARD_DATASERIEVALUE: "deleteVariableValue",
};

export const __ButtonKeys_KPI = [
  { key: enum__BUTTONKEYS_KPI.PROCESS_GAP },
  { key: enum__BUTTONKEYS_KPI.PROCESS_GAP_REVISION },
  { key: enum__BUTTONKEYS_KPI.PROCESS_GAP_CAUSES },
  { key: enum__BUTTONKEYS_KPI.SELECT_GAP_FISHBONE },

  { key: enum__BUTTONKEYS_KPI.CREATE_BOARD },
  { key: enum__BUTTONKEYS_KPI.MOVE_BOARD_ZONES },

  { key: enum__BUTTONKEYS_KPI.ADD_BOARD_DATASERIEVALUE },
  { key: enum__BUTTONKEYS_KPI.ADD_BOARD_DATASERIEVALUE_DOCUMENT },
  { key: enum__BUTTONKEYS_KPI.ADD_BOARD_CONSOLIDATION_GROUP },
  { key: enum__BUTTONKEYS_KPI.ADD_GAP_REVISION },
  { key: enum__BUTTONKEYS_KPI.GRUD_GAP_GENERAL_COMMENTS },
  { key: enum__BUTTONKEYS_KPI.GRUD_GAP_ACTIONS },

  { key: enum__BUTTONKEYS_KPI.EDIT_BOARD },
  { key: enum__BUTTONKEYS_KPI.EDIT_BOARD_CONTAINER_TITLES },
  { key: enum__BUTTONKEYS_KPI.EDIT_BOARD_DATASERIEVALUE },
  { key: enum__BUTTONKEYS_KPI.EDIT_BOARD_DATASERIE_INFO },
  { key: enum__BUTTONKEYS_KPI.CLOSE_BOARD_DATASERIE },
  { key: enum__BUTTONKEYS_KPI.DELETE_BOARD_DATASERIEVALUE },
];

///////////End Transversal///////////

///////////Book///////////
export const __BookStatus = [
  { key: 0, value: "data-lang-business-bookstatus-0" },
  { key: 1, value: "data-lang-business-bookstatus-1" },
  { key: 2, value: "data-lang-business-bookstatus-2" },
  { key: 3, value: "data-lang-business-bookstatus-3" },
  { key: 4, value: "data-lang-business-bookstatus-4" },
  { key: 5, value: "data-lang-business-bookstatus-5" },
];

export const __PartyType = { LegalEntity: 1, BusinessUnit: 2 };

export const __BookRelatedConceptTypes = [
  { id: 1, code: "RC1", text: "data-lang-lbl-project", selected: false },
  { id: 2, code: "RC2", text: "data-lang-lbl-contract", selected: false },
];

//export const enum__BookRoles = {
//    Aprobador: 1,
//    Creador: 2,
//    Lectura: 3,
//};

export const enum__BookRoles = {
  //Configuador -- Configura el libro.
  Configure: "CFG",
  //Jefe de proyecto
  Aprobador: "JPO",
  //Colaborador
  Creador: "COL",
  //Rol informado
  Lectura: "INF",
  Supervisor: "SUP",
};

export const __BookRoles = [
  {
    id: 23,
    partyMemberRoleCode: enum__BookRoles.Configure,
    partyMemberRoleNemo: "PVRLE24",
    name: "Asesor administrativo",
  },
  {
    id: 24,
    partyMemberRoleCode: enum__BookRoles.Aprobador,
    partyMemberRoleNemo: "PVRLE25",
    name: "Administrador",
  },
  {
    id: 25,
    partyMemberRoleCode: enum__BookRoles.Creador,
    partyMemberRoleNemo: "PVRLE26",
    name: "Colaborador",
  },
  {
    id: 26,
    partyMemberRoleCode: enum__BookRoles.Lectura,
    partyMemberRoleNemo: "PVRLE27",
    name: "Rol informado",
  },
    {
    id: 32,
    partyMemberRoleCode: enum__BookRoles.Supervisor,
    partyMemberRoleNemo: "PVRLE32",
    name: "Supervisor",
  },
];
///////////End Book///////////

///////////KPI///////////

export const __BoardStatus = [
  { key: 0, value: "data-lang-sk-business-boardstatus-0" },
  { key: 1, value: "data-lang-sk-business-boardstatus-1" },
  { key: 2, value: "data-lang-sk-business-boardstatus-2" },
  { key: 3, value: "data-lang-sk-business-boardstatus-3" },
  { key: 4, value: "data-lang-sk-business-boardstatus-4" },
];

export const enum__KPIPeriods = {
  YEAR: 1,
  MONTH: 2,
  DAY: 3,
  HOUR: 4,
  SHIFT: 5,
  ANY: 6,
};

export const __KPIPeriods = [
  {
    key: enum__KPIPeriods.YEAR,
    text: `data-lang-lbl-year`,
    title: `data-lang-lbl-year`,
    type: "decade",
    apiType: "year",
  },
  {
    key: enum__KPIPeriods.MONTH,
    text: `data-lang-lbl-month`,
    title: `data-lang-lbl-month`,
    type: "year",
    apiType: "month",
  },
  {
    key: enum__KPIPeriods.DAY,
    text: `data-lang-lbl-day`,
    title: `data-lang-lbl-day`,
    type: "month",
    apiType: "day",
  },
  {
    key: enum__KPIPeriods.HOUR,
    text: `data-lang-lbl-hour`,
    title: `data-lang-lbl-hour`,
    type: "hour",
    apiType: "hour",
  },
  {
    key: enum__KPIPeriods.SHIFT,
    text: `data-lang-lbl-shift`,
    title: `data-lang-lbl-shift`,
    type: "shift",
    apiType: "shift",
  },
  {
    key: enum__KPIPeriods.ANY,
    text: `data-lang-lbl-any`,
    title: `data-lang-lbl-any`,
    type: "any",
    apiType: "any",
  },
];

export const __KPIAgregationTypes = [
  { key: 1, text: `NO_AGG`, title: `NO_AGG` },
  { key: 2, text: `DF_AGG`, title: `DF_AGG` },
];

export const enum__KPIAgregations = {
  SUM: 1,
  HALF: 2,
};
export const __KPIAgregations = [
  {
    key: enum__KPIAgregations.SUM,
    text: `data-lang-sktimeaggregation-sum`,
    title: `data-lang-sktimeaggregation-sum`,
  },
  {
    key: enum__KPIAgregations.HALF,
    text: `data-lang-sktimeaggregation-half`,
    title: `data-lang-sktimeaggregation-half`,
  },
];

export const enum__CONTRACTUAL = {
  YES: true,
  NO: false,
};
export const __CONTRACTUAL = [
  {
    key: enum__CONTRACTUAL.YES,
    text: `data-lang-lbl-yes`,
    title: `data-lang-lbl-yes`,
  },
  {
    key: enum__CONTRACTUAL.NO,
    text: `data-lang-lbl-no`,
    title: `data-lang-lbl-no`,
  },
];

export const enum__AppElementType = {
  CONTRACT: 1,
  PROJECT: 2,
  BOOK: 3,
  BUSINESS_UNIT: 9,
};

export const __AppElementType = [
  {
    id: enum__AppElementType.CONTRACT,
    apElementNemo: "AE1",
    appElementCode: "AE1",
    elementName: "data-lang-lbl-contract",
    tableName: "contract",
    codeFieldName: "code",
    nameFieldName: "name",
  },
  {
    id: enum__AppElementType.PROJECT,
    apElementNemo: "AE2",
    appElementCode: "AE2",
    elementName: "data-lang-lbl-project",
    tableName: "project",
    codeFieldName: "code",
    nameFieldName: "name",
  },
  {
    id: enum__AppElementType.BOOK,
    apElementNemo: "AE3",
    appElementCode: "AE3",
    elementName: "data-lang-lbl-book",
    tableName: "sb_book",
    codeFieldName: "code",
    nameFieldName: "name",
  },
  {
    id: enum__AppElementType.BUSINESS_UNIT,
    apElementNemo: "AE9",
    appElementCode: "AE9",
    elementName: "data-lang-lbl-businessunit",
    tableName: "business_unit",
    codeFieldName: "code",
    nameFieldName: "name",
  },
];

export const __Months = [
  { key: "01", name: "data-lang-lbl-calendar-shortmonth-january" },
  { key: "02", name: "data-lang-lbl-calendar-shortmonth-february" },
  { key: "03", name: "data-lang-lbl-calendar-shortmonth-march" },
  { key: "04", name: "data-lang-lbl-calendar-shortmonth-april" },
  { key: "05", name: "data-lang-lbl-calendar-shortmonth-may" },
  { key: "06", name: "data-lang-lbl-calendar-shortmonth-june" },
  { key: "07", name: "data-lang-lbl-calendar-shortmonth-july" },
  { key: "08", name: "data-lang-lbl-calendar-shortmonth-august" },
  { key: "09", name: "data-lang-lbl-calendar-shortmonth-september" },
  { key: "10", name: "data-lang-lbl-calendar-shortmonth-october" },
  { key: "11", name: "data-lang-lbl-calendar-shortmonth-november" },
  { key: "12", name: "data-lang-lbl-calendar-shortmonth-december" },
];

export const __Currencies = [
  { key: 0, text: "Ninguno", title: "Ninguno", currencyNemo: "" },
  {
    key: 1,
    text: "CLP",
    title: "CLP",
    currencyNemo: "CRR1",
    name: "pesos chilenos",
  },
  { key: 2, text: "USD", title: "USD", currencyNemo: "CRR2", name: "dolar" },
  {
    key: 3,
    text: "UF",
    title: "UF",
    currencyNemo: "CRR3",
    name: "unidad fomento",
  },
];

export const __Numberfixed = [
  { key: 0, text: "0", title: "0" },
  { key: 1, text: "1", title: "1" },
  { key: 2, text: "2", title: "2" },
  { key: 3, text: "3", title: "3" },
  { key: 4, text: "4", title: "4" },
  { key: 5, text: "5", title: "5" },
];

export const __ElementColor = [
  { id: "a", label: "gray", color: "#a1a1a1" },
  { id: "b", label: "green", color: "#7fd7a7" },
  { id: "c", label: "blue", color: "#a1b8e1" },
  { id: "d", label: "yellow", color: "#bdbd63" },
  { id: "e", label: "orange", color: "#ffa97f" },
  { id: "f", label: "red", color: "#ff7f7f" },
];

export const enum__BoardRoles = {
  ADMIN: 1, //Administrador
  ATO: 2, //Asesor tecnico operacional
  AC: 3, //Asesor comercial
  ESPEC: 4, //Especialista
  GC: 5, //Gestor contratación
  RF: 6, //Rol facultado
  RF2: 13, //Rol facultado
  RF3: 18, //Rol facultado
  RI: 7, //Rol informado
  RI1: 14, //Rol informado
  RI2: 19, //Rol informado
  TRAB: 8, //Trabajador
  JP: 9, //Jefe proyecto
  PMO: 10, //PMO
  INTE: 11, //Integrante
  INTE2: 16, //Integrante
  COE: 12, //Colaborador externo
  COE2: 17, //Colaborador externo
  JBU: 15, //Jefe BU
  All: -1,
  None: -2,
};

export const __BoardRoles = [
  { id: enum__BoardRoles.ADMIN, ShortText: "ADN" },
  { id: enum__BoardRoles.ATO, ShortText: "ATO" },
  { id: enum__BoardRoles.AC, ShortText: "AC" },
  { id: enum__BoardRoles.ESPEC, ShortText: "ESPEC" },
  { id: enum__BoardRoles.GC, ShortText: "GC" },
  { id: enum__BoardRoles.RF, ShortText: "RF" },
  { id: enum__BoardRoles.RF2, ShortText: "RF" },
  { id: enum__BoardRoles.RF3, ShortText: "RF" },
  { id: enum__BoardRoles.RI, ShortText: "RI" },
  { id: enum__BoardRoles.RI2, ShortText: "RI" },
  { id: enum__BoardRoles.RI3, ShortText: "RI" },
  { id: enum__BoardRoles.TRAB, ShortText: "TRAB" },
  { id: enum__BoardRoles.JP, ShortText: "JP" },
  { id: enum__BoardRoles.PMO, ShortText: "PMO" },
  { id: enum__BoardRoles.INTE, ShortText: "INTE" },
  { id: enum__BoardRoles.INTE2, ShortText: "INTE" },
  { id: enum__BoardRoles.COE, ShortText: "COE" },
  { id: enum__BoardRoles.COE2, ShortText: "COE" },
  { id: enum__BoardRoles.JBU, ShortText: "JBU" },
];

export const __BoardFilterFields = [
  {
    index: 0,
    simbol: null,
    label: "data-lang-lbl-field-serieTime",
    enabled: false,
    field: "serieTime",
    isChecked: true,
  },
  {
    index: 1,
    simbol: null,
    label: "data-lang-lbl-field-displayValue",
    enabled: false,
    field: "displayValue",
    isChecked: true,
  },
  {
    index: 2,
    simbol: null,
    label: "data-lang-lbl-field-valueReal",
    enabled: true,
    field: "valueReal",
    isChecked: false,
  },
  {
    index: 3,
    simbol: null,
    label: "data-lang-lbl-field-valueProvisory",
    enabled: true,
    field: "valueProvisory",
    isChecked: false,
  },
  {
    index: 4,
    simbol: null,
    label: "data-lang-lbl-field-valueBudget",
    enabled: true,
    field: "valueBudget",
    isChecked: false,
  },
  {
    index: 5,
    simbol: null,
    label: "data-lang-lbl-field-valueForecast",
    enabled: true,
    field: "valueForecast",
    isChecked: false,
  },
  {
    index: 6,
    simbol: null,
    label: "data-lang-lbl-field-valueGoal",
    enabled: false,
    field: "valueGoal",
    isChecked: true,
  },
  {
    index: 7,
    simbol: "%",
    label: "data-lang-lbl-field-valueGoalPercent",
    enabled: false,
    field: "valueGoalPercent",
    isChecked: true,
  },
  {
    index: 8,
    simbol: null,
    label: "data-lang-lbl-field-AGGR_TYPE",
    enabled: true,
    field: "AGGR_TYPE",
    isChecked: false,
  },
];

export const __BoardFilterFields_DefaultValues = [
  {
    index: 0,
    simbol: null,
    label: "data-lang-lbl-field-serieTime",
    enabled: false,
    field: "serieTime",
    isChecked: true,
  },
  {
    index: 1,
    simbol: null,
    label: "data-lang-lbl-field-displayValue",
    enabled: false,
    field: "displayValue",
    isChecked: true,
  },
  {
    index: 6,
    simbol: null,
    label: "data-lang-lbl-field-valueGoal",
    enabled: false,
    field: "valueGoal",
    isChecked: true,
  },
  {
    index: 7,
    simbol: "%",
    label: "data-lang-lbl-field-valueGoalPercent",
    enabled: false,
    field: "valueGoalPercent",
    isChecked: true,
  },
];

export const __HoursValues = [
  { key: 0, value: "00:00" },
  { key: 100, value: "01:00" },
  { key: 200, value: "02:00" },
  { key: 300, value: "03:00" },
  { key: 400, value: "04:00" },
  { key: 500, value: "05:00" },
  { key: 600, value: "06:00" },
  { key: 700, value: "07:00" },
  { key: 800, value: "08:00" },
  { key: 900, value: "09:00" },
  { key: 1000, value: "10:00" },
  { key: 1100, value: "11:00" },
  { key: 1200, value: "12:00" },
  { key: 1300, value: "13:00" },
  { key: 1400, value: "14:00" },
  { key: 1500, value: "15:00" },
  { key: 1600, value: "16:00" },
  { key: 1700, value: "17:00" },
  { key: 1800, value: "18:00" },
  { key: 1900, value: "19:00" },
  { key: 2000, value: "20:00" },
  { key: 2100, value: "21:00" },
  { key: 2200, value: "22:00" },
  { key: 2300, value: "23:00" },
];

export const __ShiftValues = [
  { key: 1, text: "1" },
  { key: 2, text: "2" },
];

export const enum__ActionStatus = {
  GAP_ACTION: 1,
  GAP_ACTION_ENGAGED: 2, //Para pasar aquí desde GAP_ACTION debe tener owner, executor, start y end date.
  GAP_ACTION_PENDING: 3, //Una acción pentiende está comprometida pero pendiente de término.
  GAP_ACTION_COMPLETED: 4,
  GAP_ACTION_CANCELED: 5,
  GAP_ACTION_COMPLETED_UNVALIDATED: 6,
};

export const __ActionStatus = [
  {
    index: 1,
    keyword: "GAP_ACTION",
    key: enum__ActionStatus.GAP_ACTION,
    text: "data-lang-skaction-status1",
    iconName: "NewFolder",
    iconColor: "white",
    circleColor: "blue",
  },
  {
    index: 3,
    keyword: "GAP_ACTION_ENGAGED",
    key: enum__ActionStatus.GAP_ACTION_ENGAGED,
    text: "data-lang-skaction-status2",
    iconName: "Calendar",
    iconColor: "white",
    circleColor: "gray",
  },
  {
    index: 4,
    keyword: "GAP_ACTION_PENDING",
    key: enum__ActionStatus.GAP_ACTION_PENDING,
    text: "data-lang-skaction-status3",
    iconName: "DateTimeMirrored",
    iconColor: "white",
    circleColor: "orange",
  },
  {
    index: 6,
    keyword: "GAP_ACTION_COMPLETED",
    key: enum__ActionStatus.GAP_ACTION_COMPLETED,
    text: "data-lang-skaction-status4",
    iconName: "EventAccepted",
    iconColor: "white",
    circleColor: "green",
  },
  {
    index: 2,
    keyword: "GAP_ACTION_CANCELED",
    key: enum__ActionStatus.GAP_ACTION_CANCELED,
    text: "data-lang-skaction-status5",
    iconName: "EventDeclined",
    iconColor: "white",
    circleColor: "red",
  },
  {
    index: 5,
    keyword: "GAP_ACTION_COMPLETED_UNVALIDATED",
    key: enum__ActionStatus.GAP_ACTION_COMPLETED_UNVALIDATED,
    text: "data-lang-skaction-status6",
    iconName: "EventDeclined",
    iconColor: "white",
    circleColor: "red",
  },
];

export const enum__RevisionStatus = {
  GAP_REVISION: 1,
  GAP_REVISION_ANALYZE: 2,
  GAP_REVISION_DIALOGUE: 3,
  GAP_REVISION_REVISION: 4,
  GAP_REVISION_END: 5,
};

export const __RevisionStatus = [
  {
    keyword: "",
    key: enum__RevisionStatus.GAP_REVISION,
    text: "data-lang-skrevision-status1",
  },
  {
    keyword: "",
    key: enum__RevisionStatus.GAP_REVISION_ANALYZE,
    text: "data-lang-skrevision-status2",
  },
  {
    keyword: "",
    key: enum__RevisionStatus.GAP_REVISION_DIALOGUE,
    text: "data-lang-skrevision-status3",
  },
  {
    keyword: "",
    key: enum__RevisionStatus.GAP_REVISION_REVISION,
    text: "data-lang-skrevision-status4",
  },
  {
    keyword: "",
    key: enum__RevisionStatus.GAP_REVISION_END,
    text: "data-lang-skrevision-status5",
  },
];

export const enum__Objetives = {
  MAXIMIZE: 1,
  MINIMIZE: 2,
  MATCH: 3,
  STABILIZE: 4,
};

export const __OBJETIVES = [
  { key: enum__Objetives.MAXIMIZE, name: "MAXIMIZE" },
  { key: enum__Objetives.MINIMIZE, name: "MINIMIZE" },
  { key: enum__Objetives.MATCH, name: "MATCH" },
  { key: enum__Objetives.STABILIZE, name: "STABILIZE" },
];

export const enum__ComponentType = {
  LIST: 1,
  CHART: 2,
  SIMPLE: 3,
  DETAILED: 4,
  COLOR: 5,
  SG3KPI_GAPACCIONES: 6,
  SG3KPI_GAPEVENTOS: 7,
  SG3BOOK_LIBROS: 8,
  SG3BOOK_EVENTOS: 9,
  SG3_HEADER: 10,
  OCR_CHART: 11,
  SG3KPI_RADIAL: 12,
  SG3KPI_EVENTOS: 13,
  /// <summary>
  /// apertura mensual de grupos consolidados
  /// </summary>
  SG3KPI_CONSOLIDATE_MONTH: 14,
  OCR_CHART_GAUGE: 15,
  INFO_SIMPLE_KPI: 16,
  INFO_ACTION_V2: 17,
  INFO_TYPETEXT: 18,
  /// <summary>
  /// el conetenido es del board, aun asi se devuelve el elemento en caso de hacer referncia a un custom text expecifico de un elemento
  /// </summary>
  INFO_COMMENT: 19,

  /// <summary>
  /// la info financial es de un KPI que pertenecese a un dataserie y a un elemento
  /// </summary>
  INFO_FINANCIAL: 20,
  DS_SIMPLEDATA_PERFORMANCE: 21,
  DS_SIMPLEDATA: 22,
  /// <summary>
  /// el conetenido es del board, aun asi se devuelve el elemento en caso de hacer referncia a un custom text expecifico de un elemento
  /// </summary>
  INFO_CUSTOMTEXT: 23,
  /// <summary>
  /// piramide contractual segmentos
  /// </summary>
  ELEMENT_CONTRACT_SEGMENT: 24,
  /// <summary>
  /// agrupacion categoría contratos
  /// </summary>
  ELEMENT_CONTRACT_CATEGORY: 25,
  /// <summary>
  /// informacion relacionada a la cartera de contratos
  /// </summary>
  ELEMENT_CONTRACT_PORTFOLIO_SUMMARY: 26,
  /// <summary>
  /// Lista contratos, codigo, nombre, eecc, area, sermento, moneda, monto, gasto, meta, variacion, dotacion. La variación agrega, n kpi, n accione,s n comunicaciones.
  /// </summary>
  ELEMENT_CONTRACT_KPI_DETAIL: 27,
  /// <summary>
  /// Despliega kpi dotacion de contratos y agrupadas por mes
  /// </summary>
  ELEMENT_KPI_FTE_CHART: 28,
  /// <summary>
  /// despliega monto gasto de contratos agrupados por periodo, despliega tendendia, lo graficado es por unidad medida.
  /// </summary>
  ELEMENT_KPI_AMOUNT: 29,
  /// <summary>
  /// Depsliegue de dotacion de contratos
  /// </summary>
  ELEMENT_KPI_FTE_TREE: 30,
  /// <summary>
  /// Partidas y su estado de manipulacion de 1 contrato en particular
  /// </summary>
  CONTRACT_SERVICES: 31,
  /// <summary>
  /// ultimos movimientos de un elemento
  /// </summary>
  ELEMENT_LAST_MOVEMENTS: 32,
  /// <summary>
  /// roles asociados al usuario
  /// </summary>
  ELEMENT_ROLES: 33,
  /// <summary>
  /// estadisticas de elemntos creados de kpi, acciones, comunicaciones
  /// </summary>
  ELEMENT_STADISTICS: 34,
  /// <summary>
  /// estado gasto asociado a las partidas de deservicio
  /// </summary>
  CONTRACT_SERVICES_STATUS: 35,
  /// <summary>
  /// muestra la informacion de un contrato en particular, relacionada a un EDP
  /// </summary>
  CONTRACT_LAST_EDP: 36,
  /// <summary>
  /// muestra la cobertura de un contrato en particular, fecha  de inicio y termino y KPI de cobertura
  /// </summary>
  CONTRACT_KPI_COVERAGE: 37,
  /// <summary>
  /// resumen de libros y sus comunicaciones asociadas a un elemento de negocio en particular.
  /// </summary>
  ELEMENT_BOOK_SUMMARY: 38,
  /// <summary>
  /// trae los eventos y coments de un kpi que pertenece a un elemento
  /// </summary>
  ELEMENT_KPI_COMMENT_EVENT: 39,
  /// <summary>
  /// muestra el mismo KPI relacionado en base al kpi maestro de los elementos relacionados al tablero
  /// </summary>
  ELEMENT_KPI_VARIABLE_DETAILS: 40,
  /// <summary>
  /// muestra informacion de KPI
  /// </summary>
  ELEMENT_KPI_SUMMARY: 41, //En ComponentInfo este usa el texto 'CRITICO' o 'VENCIDA' (En verdad valida que sea CRITICO, si no es ese para cualquier otro texto asume VENCIDA).
  /// <summary>
  /// muestra informacion de book
  /// </summary>
  ELEMENT_BOOK_STATUS_SUMMARY: 42,
  /// <summary>
  /// muestra relacion del gasto vs saldo de los edp de contrato
  /// </summary>
  ELEMENT_CONTRACT_EXPENSE_BALANCE: 43,
  /// <summary>
  /// grafico partidas de contrato y su distribucion de gastos
  /// </summary>
  ELEMENT_CONTRACT_SERVICE_SUMMARY: 44,
  /// <summary>
  /// grafico de contrato y distribucion de gasto de los EDP
  /// </summary>
  ELEMENT_CONTRACT_EXPENSE_BALANCE_DETAIL: 45,
  /// <summary>
  /// tabla ultimos edp de un contrato
  /// </summary>
  ELEMENT_CONTRACT_LIST_LAST_EDP: 46,
  /// <summary>
  /// ultimo estado de pago de un contrato
  /// </summary>
  ELEMENT_CONTRACT_LAST_EDP: 47,
  /// <summary>
  /// caratula contrato de un estado de pago
  /// </summary>
  ELEMENT_CONTRACT_EDP_COVER: 48,
  ELEMENT_OBLIGATIONS_CONTROL: 49,
  PRODUCTS: 50,
  SG3KPI_RADIALOPF: 51,
  ELEMENT_KPI_SCOPE: 52, //En ComponentInfo este usa el nemo del scope.
  SG3KPI_MONITORING: 53,
  SG3KPI_LASTOPF: 54,
  SG3KPI_CONTRACT_ADVANCE: 55,

  ELEMENT_CONTRACT_LIST_TO_COMPARE: 56,
  CONSOLIDATE_GROUP_LIST_TO_SELECT: 57,
  CONSOLIDATE_GROUP_CONSOLIDATE_OPF: 58,
  CONSOLIDATE_GROUP_CONSOLIDATE_CHART: 59,
  CONSOLIDATE_GROUP_CONTRACT_FILTER_TO_COMPARE: 60,

  ELEMENT_CONTRACT_EDP_RESUMEN: 61,
  ELEMENT_CONTRACT_EDP_DISTRIBUCION: 62,
  ELEMENT_CONTRACT_EDP_PARTIDAS_GRAPH: 63,
  ELEMENT_CONTRACT_EDP_MONTOS_GRAPH: 64,
  ELEMENT_CONTRACT_MOTNHS: 65,
  ELEMENT_CONTRACT_EDP_PARTIDAS_TBL: 66,
  ELEMENT_KPI_CONTRACT_LIST_BYROLE: 67,
  ELEMENT_KPI_LIST_BYROLE: 68,
  OCR_CHART_LIST: 69,
  ELEMENT_CONTRACT_EXCHANGE_RATE: 70,
  POWERBI_COMPONENT_TABLE: 71,
  POWERBI_COMPONENT_KEY_KPIS: 72,
  POWERBI_COMPONENT_OCR: 73,
  CONSOLIDATE_GROUP_CONTRACT_FILTER_AGRUPATION_SERIE: 74,
};
export const enum__ComponentType_InvertedEnum = Object.entries(
  enum__ComponentType,
).reduce((acc, [key, value]) => ({ ...acc, [value]: key }), {});
export const __ComponentTypes = [
  {
    key: enum__ComponentType.INFO_SIMPLE_KPI,
    minWidthPoints: 5,
    minHeigthPoints: 4,
    text: "data-lang-componenttype-kpi",
    title: "data-lang-componenttype-kpi",
    selected: false,
  },
  {
    key: enum__ComponentType.INFO_ACTION_V2,
    minWidthPoints: 5,
    minHeigthPoints: 4,
    text: "data-lang-componenttype-actions",
    title: "data-lang-componenttype-actions",
    selected: false,
  },
  {
    key: enum__ComponentType.INFO_TYPETEXT,
    minWidthPoints: 5,
    minHeigthPoints: 4,
    text: "data-lang-componenttype-text",
    title: "data-lang-componenttype-text",
    selected: false,
  },
  {
    key: enum__ComponentType.INFO_COMMENT,
    minWidthPoints: 5,
    minHeigthPoints: 1,
    text: "data-lang-componenttype-comment",
    title: "data-lang-componenttype-comment",
    selected: false,
  },
  {
    key: enum__ComponentType.INFO_FINANCIAL,
    minWidthPoints: 5,
    minHeigthPoints: 4,
    text: "data-lang-componenttype-financial",
    title: "data-lang-componenttype-financial",
    selected: false,
  },
  {
    key: enum__ComponentType.DS_SIMPLEDATA_PERFORMANCE,
    minWidthPoints: 5,
    minHeigthPoints: 4,
    text: "data-lang-componenttype-performance",
    title: "data-lang-componenttype-performance",
    selected: false,
  },
  {
    key: enum__ComponentType.DS_SIMPLEDATA,
    minWidthPoints: 5,
    minHeigthPoints: 4,
    text: "data-lang-componenttype-simpledata",
    title: "data-lang-componenttype-simpledata",
    selected: false,
  },
  {
    key: enum__ComponentType.INFO_CUSTOMTEXT,
    minWidthPoints: 5,
    minHeigthPoints: 4,
    text: "data-lang-componenttype-singletext",
    title: "data-lang-componenttype-singletext",
    selected: false,
  },

  {
    key: enum__ComponentType.LIST,
    minWidthPoints: 5,
    minHeigthPoints: 4,
    text: "data-lang-componenttype-list",
    title: "data-lang-componenttype-list",
    selected: false,
  },
  {
    key: enum__ComponentType.CHART,
    minWidthPoints: 5,
    minHeigthPoints: 4,
    text: "data-lang-componenttype-chart",
    title: "data-lang-componenttype-chart",
    selected: false,
  },
  {
    key: enum__ComponentType.SIMPLE,
    minWidthPoints: 5,
    minHeigthPoints: 4,
    text: "data-lang-componenttype-simple",
    title: "data-lang-componenttype-simple",
    selected: false,
  },
  {
    key: enum__ComponentType.DETAILED,
    minWidthPoints: 5,
    minHeigthPoints: 4,
    text: "data-lang-componenttype-detailed",
    title: "data-lang-componenttype-detailed",
    selected: false,
  },
  {
    key: enum__ComponentType.COLOR,
    minWidthPoints: 5,
    minHeigthPoints: 4,
    text: "data-lang-componenttype-color",
    title: "data-lang-componenttype-color",
    selected: false,
  },

  {
    key: enum__ComponentType.SG3KPI_GAPACCIONES,
    minWidthPoints: 5,
    minHeigthPoints: 4,
    text: "data-lang-componenttype-sg3kpi_gapactions",
    title: "data-lang-componenttype-sg3kpi_gapactions",
    selected: false,
  },
  {
    key: enum__ComponentType.SG3KPI_GAPEVENTOS,
    minWidthPoints: 5,
    minHeigthPoints: 4,
    text: "data-lang-componenttype-sg3kpi_gapevents",
    title: "data-lang-componenttype-sg3kpi_gapevents",
    selected: false,
  },
  {
    key: enum__ComponentType.SG3BOOK_LIBROS,
    minWidthPoints: 5,
    minHeigthPoints: 4,
    text: "data-lang-componenttype-sg3book_books",
    title: "data-lang-componenttype-sg3book_books",
    selected: false,
  },
  {
    key: enum__ComponentType.SG3BOOK_EVENTOS,
    minWidthPoints: 5,
    minHeigthPoints: 4,
    text: "data-lang-componenttype-sg3book_events",
    title: "data-lang-componenttype-sg3book_events",
    selected: false,
  },
  {
    key: enum__ComponentType.SG3_HEADER,
    minWidthPoints: 7,
    minHeigthPoints: 6,
    text: "data-lang-componenttype-header",
    title: "data-lang-componenttype-header",
    selected: false,
  },
  {
    key: enum__ComponentType.OCR_CHART,
    minWidthPoints: 15,
    minHeigthPoints: 6,
    text: "data-lang-componenttype-ocrchart",
    title: "data-lang-componenttype-ocrchart",
    selected: false,
  },
  {
    key: enum__ComponentType.SG3KPI_RADIAL,
    minWidthPoints: 11,
    minHeigthPoints: 6,
    text: "data-lang-componenttype-sg3kpi_radial",
    title: "data-lang-componenttype-radial",
    selected: false,
  },
  {
    key: enum__ComponentType.SG3KPI_EVENTOS,
    minWidthPoints: 5,
    minHeigthPoints: 4,
    text: "data-lang-componenttype-sg3kpi_events",
    title: "data-lang-componenttype-sg3kpi_radial",
    selected: false,
  },
  {
    key: enum__ComponentType.SG3KPI_CONSOLIDATE_MONTH,
    minWidthPoints: 14,
    minHeigthPoints: 6,
    text: "data-lang-componenttype-sg3kpi_consolidatemonth",
    title: "data-lang-componenttype-sg3kpi_consolidatemonth",
    selected: false,
  },
  {
    key: enum__ComponentType.OCR_CHART_GAUGE,
    minWidthPoints: 15,
    minHeigthPoints: 6,
    text: "data-lang-componenttype-gaugechart",
    title: "data-lang-componenttype-gaugechart",
    selected: false,
  },
  {
    key: enum__ComponentType.ELEMENT_CONTRACT_SEGMENT,
    minWidthPoints: 7,
    minHeigthPoints: 5,
    text: "data-lang-componenttype-elementcontract_segment",
    title: "data-lang-componenttype-elementcontract_segment",
    selected: false,
  },
  {
    key: enum__ComponentType.ELEMENT_CONTRACT_CATEGORY,
    minWidthPoints: 6,
    minHeigthPoints: 4,
    text: "data-lang-componenttype-elementcontract_category",
    title: "data-lang-componenttype-elementcontract_category",
    selected: false,
  },
  {
    key: enum__ComponentType.ELEMENT_CONTRACT_PORTFOLIO_SUMMARY,
    minWidthPoints: 9,
    minHeigthPoints: 6,
    text: "data-lang-componenttype-elementcontract_portfoliosummary",
    title: "data-lang-componenttype-elementcontract_portfoliosummary",
    selected: false,
  },
  {
    key: enum__ComponentType.ELEMENT_CONTRACT_KPI_DETAIL,
    minWidthPoints: 21,
    minHeigthPoints: 4,
    text: "data-lang-componenttype-elementcontract_kpidetail",
    title: "data-lang-componenttype-elementcontract_kpidetail",
    selected: false,
  },
  {
    key: enum__ComponentType.ELEMENT_KPI_FTE_CHART,
    minWidthPoints: 14,
    minHeigthPoints: 5,
    text: "data-lang-componenttype-element_kpiftedetail",
    title: "data-lang-componenttype-element_kpiftedetail",
    selected: false,
  },
  {
    key: enum__ComponentType.ELEMENT_KPI_AMOUNT,
    minWidthPoints: 9,
    minHeigthPoints: 5,
    text: "data-lang-componenttype-element_kpiamount",
    title: "data-lang-componenttype-element_kpiamount",
    selected: false,
  },
  {
    key: enum__ComponentType.ELEMENT_KPI_FTE_TREE,
    minWidthPoints: 7,
    minHeigthPoints: 6,
    text: "data-lang-componenttype-element_kpi_fte_tree",
    title: "data-lang-componenttype-element_kpi_fte_tree",
    selected: false,
  },
  {
    key: enum__ComponentType.CONTRACT_SERVICES,
    minWidthPoints: 5,
    minHeigthPoints: 5,
    text: "data-lang-componenttype-contract_service",
    title: "data-lang-componenttype-contract_service",
    selected: false,
  },
  {
    key: enum__ComponentType.ELEMENT_LAST_MOVEMENTS,
    minWidthPoints: 7,
    minHeigthPoints: 7,
    text: "data-lang-componenttype-element_lastmoments",
    title: "data-lang-componenttype-element_lastmoments",
    selected: false,
  },
  {
    key: enum__ComponentType.ELEMENT_ROLES,
    minWidthPoints: 5,
    minHeigthPoints: 5,
    text: "data-lang-componenttype-element_roles",
    title: "data-lang-componenttype-element_roles",
    selected: false,
  },
  {
    key: enum__ComponentType.ELEMENT_STADISTICS,
    minWidthPoints: 25,
    minHeigthPoints: 3,
    text: "data-lang-componenttype-element_stadistic",
    title: "data-lang-componenttype-element_stadistic",
    selected: false,
  },
  {
    key: enum__ComponentType.CONTRACT_SERVICES_STATUS,
    minWidthPoints: 15,
    minHeigthPoints: 4,
    text: "data-lang-componenttype-contract_servicesstatus",
    title: "data-lang-componenttype-contract_servicesstatus",
    selected: false,
  },
  {
    key: enum__ComponentType.CONTRACT_LAST_EDP,
    minWidthPoints: 10,
    minHeigthPoints: 6,
    text: "data-lang-componenttype-contract_edp",
    title: "data-lang-componenttype-contract_edp",
    selected: false,
  },
  {
    key: enum__ComponentType.CONTRACT_KPI_COVERAGE,
    minWidthPoints: 6,
    minHeigthPoints: 5,
    text: "data-lang-componenttype-contract_kpicoverage",
    title: "data-lang-componenttype-contract_kpicoverage",
    selected: false,
  },
  {
    key: enum__ComponentType.ELEMENT_BOOK_SUMMARY,
    minWidthPoints: 15,
    minHeigthPoints: 3,
    text: "data-lang-componenttype-elementbook_summary",
    title: "data-lang-componenttype-elementbook_summary",
    selected: false,
  },
  {
    key: enum__ComponentType.ELEMENT_KPI_COMMENT_EVENT,
    minWidthPoints: 7,
    minHeigthPoints: 7,
    text: "data-lang-componenttype-elementkpi_commentevent",
    title: "data-lang-componenttype-elementkpi_commentevent",
    selected: false,
  },
  {
    key: enum__ComponentType.ELEMENT_KPI_VARIABLE_DETAILS,
    minWidthPoints: 12,
    minHeigthPoints: 4,
    text: "data-lang-componenttype-elementkpi_details",
    title: "data-lang-componenttype-elementkpi_details",
    selected: false,
  },
  {
    key: enum__ComponentType.ELEMENT_KPI_SUMMARY,
    minWidthPoints: 12,
    minHeigthPoints: 4,
    text: "data-lang-componenttype-elementkpi_summary",
    title: "data-lang-componenttype-elementkpi_summary",
    selected: false,
  },
  {
    key: enum__ComponentType.ELEMENT_BOOK_STATUS_SUMMARY,
    minWidthPoints: 12,
    minHeigthPoints: 4,
    text: "data-lang-componenttype-elementbook_statussummary",
    title: "data-lang-componenttype-elementbook_statussummary",
    selected: false,
  },
  {
    key: enum__ComponentType.ELEMENT_CONTRACT_EXPENSE_BALANCE,
    minWidthPoints: 10,
    minHeigthPoints: 5,
    text: "data-lang-componenttype-elementcontract_expensebalance",
    title: "data-lang-componenttype-elementcontract_expensebalance",
    selected: false,
  },
  {
    key: enum__ComponentType.ELEMENT_CONTRACT_SERVICE_SUMMARY,
    minWidthPoints: 8,
    minHeigthPoints: 4,
    text: "data-lang-componenttype-elementcontract_servicesummary",
    title: "data-lang-componenttype-elementcontract_servicesummary",
    selected: false,
  },
  {
    key: enum__ComponentType.ELEMENT_CONTRACT_EXPENSE_BALANCE_DETAIL,
    minWidthPoints: 10,
    minHeigthPoints: 5,
    text: "data-lang-componenttype-elementcontract_expensebalancedetail",
    title: "data-lang-componenttype-elementcontract_expensebalancedetail",
    selected: false,
  },
  {
    key: enum__ComponentType.ELEMENT_CONTRACT_LIST_LAST_EDP,
    minWidthPoints: 15,
    minHeigthPoints: 4,
    text: "data-lang-componenttype-elementcontract_listlastedp",
    title: "data-lang-componenttype-elementcontract_listlastedp",
    selected: false,
  },
  {
    key: enum__ComponentType.ELEMENT_CONTRACT_LAST_EDP,
    minWidthPoints: 9,
    minHeigthPoints: 5,
    text: "data-lang-componenttype-elementcontract_lastedp",
    title: "data-lang-componenttype-elementcontract_lastedp",
    selected: false,
  },
  {
    key: enum__ComponentType.ELEMENT_CONTRACT_EDP_COVER,
    minWidthPoints: 14,
    minHeigthPoints: 13,
    text: "data-lang-componenttype-elementcontract_edpcover",
    title: "data-lang-componenttype-elementcontract_edpcover",
    selected: false,
  },
  {
    key: enum__ComponentType.ELEMENT_OBLIGATIONS_CONTROL,
    minWidthPoints: 12,
    minHeigthPoints: 10,
    text: "data-lang-componenttype-elementobligations_control",
    title: "data-lang-componenttype-elementobligations_control",
    selected: false,
  },
  {
    key: enum__ComponentType.PRODUCTS,
    minWidthPoints: 10,
    minHeigthPoints: 6,
    text: "data-lang-componenttype-products",
    title: "data-lang-componenttype-products",
    selected: false,
  },
  {
    key: enum__ComponentType.SG3KPI_RADIALOPF,
    minWidthPoints: 8,
    minHeigthPoints: 7,
    text: "data-lang-componenttype-radial_v2",
    title: "data-lang-componenttype-radial_v2",
    selected: false,
  },
  {
    key: enum__ComponentType.ELEMENT_KPI_SCOPE,
    minWidthPoints: 13,
    minHeigthPoints: 5,
    text: "data-lang-componenttype-elementkpi_scope",
    title: "data-lang-componenttype-elementkpi_scope",
    selected: false,
  },
  {
    key: enum__ComponentType.SG3KPI_MONITORING,
    minWidthPoints: 13,
    minHeigthPoints: 5,
    text: "data-lang-componenttype-sg3kpi_monitoring",
    title: "data-lang-componenttype-sg3kpi_monitoring",
    selected: false,
  },
  {
    key: enum__ComponentType.SG3KPI_LASTOPF,
    minWidthPoints: 15,
    minHeigthPoints: 6,
    text: "data-lang-componenttype-lastopf",
    title: "data-lang-componenttype-lastopf",
    selected: false,
  },
  {
    key: enum__ComponentType.SG3KPI_CONTRACT_ADVANCE,
    minWidthPoints: 13,
    minHeigthPoints: 5,
    text: "data-lang-componenttype-contractadvance",
    title: "data-lang-componenttype-contractadvance",
    selected: false,
  },

  {
    key: enum__ComponentType.ELEMENT_CONTRACT_LIST_TO_COMPARE,
    minWidthPoints: 13,
    minHeigthPoints: 5,
    text: "data-lang-componenttype-elementcontractlisttocompare",
    title: "data-lang-componenttype-elementcontractlisttocompare",
    selected: false,
  },
  {
    key: enum__ComponentType.CONSOLIDATE_GROUP_LIST_TO_SELECT,
    minWidthPoints: 13,
    minHeigthPoints: 5,
    text: "data-lang-componenttype-consolidategrouplisttoselect",
    title: "data-lang-componenttype-consolidategrouplisttoselect",
    selected: false,
  },
  {
    key: enum__ComponentType.CONSOLIDATE_GROUP_CONSOLIDATE_OPF,
    minWidthPoints: 13,
    minHeigthPoints: 5,
    text: "data-lang-componenttype-consolidategroupconsolidate_opf",
    title: "data-lang-componenttype-consolidategroupconsolidate_opf",
    selected: false,
  },
  {
    key: enum__ComponentType.CONSOLIDATE_GROUP_CONSOLIDATE_CHART,
    minWidthPoints: 13,
    minHeigthPoints: 5,
    text: "data-lang-componenttype-consolidategroupconsolidatechart",
    title: "data-lang-componenttype-consolidategroupconsolidatechart",
    selected: false,
  },
  {
    key: enum__ComponentType.CONSOLIDATE_GROUP_CONTRACT_FILTER_TO_COMPARE,
    minWidthPoints: 13,
    minHeigthPoints: 5,
    text: "data-lang-componenttype-consolidategroupcontractfiltertocompare",
    title: "data-lang-componenttype-consolidategroupcontractfiltertocompare",
    selected: false,
  },
  {
    key: enum__ComponentType.ELEMENT_CONTRACT_EDP_RESUMEN,
    minWidthPoints: 13,
    minHeigthPoints: 5,
    text: "data-lang-componenttype-elementcontractedpresumen",
    title: "data-lang-componenttype-elementcontractedpresumen",
    selected: false,
  },
  {
    key: enum__ComponentType.ELEMENT_CONTRACT_EDP_DISTRIBUCION,
    minWidthPoints: 13,
    minHeigthPoints: 5,
    text: "data-lang-componenttype-elementcontractedpdistribucion",
    title: "data-lang-componenttype-elementcontractedpdistribucion",
    selected: false,
  },
  {
    key: enum__ComponentType.ELEMENT_CONTRACT_EDP_PARTIDAS_GRAPH,
    minWidthPoints: 13,
    minHeigthPoints: 5,
    text: "data-lang-componenttype-elementcontractedppartidasgraph",
    title: "data-lang-componenttype-elementcontractedppartidasgraph",
    selected: false,
  },
  {
    key: enum__ComponentType.ELEMENT_CONTRACT_EDP_MONTOS_GRAPH,
    minWidthPoints: 13,
    minHeigthPoints: 5,
    text: "data-lang-componenttype-elementcontractedpmontosgraph",
    title: "data-lang-componenttype-elementcontractedpmontosgraph",
    selected: false,
  },
  {
    key: enum__ComponentType.ELEMENT_CONTRACT_MOTNHS,
    minWidthPoints: 13,
    minHeigthPoints: 5,
    text: "data-lang-componenttype-elementcontractmotnhs",
    title: "data-lang-componenttype-elementcontractmotnhs",
    selected: false,
  },
  {
    key: enum__ComponentType.ELEMENT_CONTRACT_EDP_PARTIDAS_TBL,
    minWidthPoints: 13,
    minHeigthPoints: 5,
    text: "data-lang-componenttype-elementcontractedppartidastbl",
    title: "data-lang-componenttype-elementcontractedppartidastbl",
    selected: false,
  },
  {
    key: enum__ComponentType.ELEMENT_KPI_CONTRACT_LIST_BYROLE,
    minWidthPoints: 13,
    minHeigthPoints: 5,
    text: "data-lang-componenttype-elementkpicontractlistbyrole",
    title: "data-lang-componenttype-elementkpicontractlistbyrole",
    selected: false,
  },
  {
    key: enum__ComponentType.ELEMENT_KPI_LIST_BYROLE,
    minWidthPoints: 13,
    minHeigthPoints: 5,
    text: "data-lang-componenttype-elementkpilistbyrole",
    title: "data-lang-componenttype-elementkpilistbyrole",
    selected: false,
  },
  {
    key: enum__ComponentType.OCR_CHART_LIST,
    minWidthPoints: 13,
    minHeigthPoints: 5,
    text: "data-lang-componenttype-ocrchartlist",
    title: "data-lang-componenttype-ocrchartlist",
    selected: false,
  },
  {
    key: enum__ComponentType.ELEMENT_CONTRACT_EXCHANGE_RATE,
    minWidthPoints: 13,
    minHeigthPoints: 5,
    text: "data-lang-componenttype-elementcontractexchangerate",
    title: "data-lang-componenttype-elementcontractexchangerate",
    selected: false,
  },
  {
    key: enum__ComponentType.POWERBI_COMPONENT_TABLE,
    minWidthPoints: 13,
    minHeigthPoints: 5,
    text: "data-lang-componenttype-powerbicomponenttable",
    title: "data-lang-componenttype-powerbicomponenttable",
    selected: false,
  },
  {
    key: enum__ComponentType.POWERBI_COMPONENT_KEY_KPIS,
    minWidthPoints: 13,
    minHeigthPoints: 5,
    text: "data-lang-componenttype-powerbicomponentkeykpis",
    title: "data-lang-componenttype-powerbicomponentkeykpis",
    selected: false,
  },
  {
    key: enum__ComponentType.POWERBI_COMPONENT_OCR,
    minWidthPoints: 13,
    minHeigthPoints: 5,
    text: "data-lang-componenttype-powerbicomponentocr",
    title: "data-lang-componenttype-powerbicomponentocr",
    selected: false,
  },
  {
    key: enum__ComponentType.CONSOLIDATE_GROUP_CONTRACT_FILTER_AGRUPATION_SERIE,
    minWidthPoints: 13,
    minHeigthPoints: 5,
    text: "data-lang-componenttype-filteragrupationseries",
    title: "data-lang-componenttype-filteragrupationseries",
    selected: false,
  },
];

export const enum__COMPONENT_SIMPLE_COLOR_TYPE = {
  NONE: 0,
  TEXT_COLOR: 1,
  BACK_COLOR: 2,
  ICON_COLOR: 3,
};

export const enum__BULK_PAYLOAD_TYPE_ID = {
  KPI: 1,
  PARTIES: 2,
  BOOK: 3,
  EDP: 4,
};

export const __BULK_PAYLOAD_TYPE_ID = [
  {
    keyTypeUniqueId: enum__PRIVILEGE_APP.KPI,
    key: 1,
    text: "data-lang-lbl-kpi",
    enabledOnlyWithElementIdAvailable: false,
  },
  {
    keyTypeUniqueId: enum__PRIVILEGE_APP.EDP,
    key: 2,
    text: "data-lang-lbl-parties",
    enabledOnlyWithElementIdAvailable: true,
  },
  {
    keyTypeUniqueId: enum__PRIVILEGE_APP.BOOK,
    key: 3,
    text: "data-lang-lbl-book",
    enabledOnlyWithElementIdAvailable: false,
  },
];

export const enum__BOARD_TEMPLATE_TYPE = {
  NONE: 0,
  LANDING: 1,
  PORTFOLIO: 2,
  BUSINESS: 3,
  OPERATIONAL: 4, //OPERACIONAL
  CONSOLIDATED: 5, //CONSOLIDADO
  MULTI: 6,
  EDP: 7,
  GAP: 8,
  POWERBI: 9,
  NOT_BOARD_COMPARE: 10,
};

export const enum__SITE_MENU_TYPE_QUICK = {
  LANDING: 1,
  PORTFOLIO: 2,
  BUSINESS: 3,
  OPERATIONAL: 4, //OPERACIONAL
  CONSOLIDATED: 5, //CONSOLIDADO
  //Multi es el reporte de tabs de AMSA.
  MULTI: 6,
  EDP: 7,
  GAP: 8,
  BOOK: 9,
  ITEMS: 10,
  ///PowerBi es el reporte de comparación de KPI.
  POWERBI: 11,
  CO: 12,
  COACHIEVES: 13,
};

export const enum__SITE_MENU_TYPE_MAIN = {
  BOOK: 1,
  CO: 2,
};

export const __BoardTemplateType = [
  {
    key: enum__BOARD_TEMPLATE_TYPE.LANDING,
    text: "data-lang-board-templatetype-landing",
    title: "data-lang-board-templatetype-landing",
    selected: false,
  },
  {
    key: enum__BOARD_TEMPLATE_TYPE.PORTFOLIO,
    text: "data-lang-board-templatetype-portfolio",
    title: "data-lang-board-templatetype-portfolio",
    selected: false,
  },
  {
    key: enum__BOARD_TEMPLATE_TYPE.BUSINESS,
    text: "data-lang-board-templatetype-business",
    title: "data-lang-board-templatetype-business",
    selected: false,
  },
  {
    key: enum__BOARD_TEMPLATE_TYPE.CONSOLIDATED,
    text: "data-lang-board-templatetype-report",
    title: "data-lang-board-templatetype-report",
    selected: false,
  },
  {
    key: enum__BOARD_TEMPLATE_TYPE.MULTI,
    text: "data-lang-board-templatetype-multielement",
    title: "data-lang-board-templatetype-multielement",
    selected: false,
  },
  {
    key: enum__BOARD_TEMPLATE_TYPE.EDP,
    text: "data-lang-board-templatetype-edp",
    title: "data-lang-board-templatetype-edp",
    selected: false,
  },
];

export const enum__FormulaId = {
  SIMPLE: 1,
  ADITIVA: 2,
  SUBTRACTIVA: 3,
  MULTIPLICATIVA: 4,
  DIVISIVA: 5,
  COCIENTE: 6,
};
export const __FormulaId = [
  {
    disabled: false,
    key: enum__FormulaId.SIMPLE,
    text: "data-lang-skformulaid-status1",
  },
  {
    disabled: true,
    key: enum__FormulaId.ADITIVA,
    text: "data-lang-skformulaid-status2",
  },
  {
    disabled: true,
    key: enum__FormulaId.SUBTRACTIVA,
    text: "data-lang-skformulaid-status3",
  },
  {
    disabled: true,
    key: enum__FormulaId.MULTIPLICATIVA,
    text: "data-lang-skformulaid-status4",
  },
  {
    disabled: true,
    key: enum__FormulaId.DIVISIVA,
    text: "data-lang-skformulaid-status5",
  },
  {
    disabled: false,
    key: enum__FormulaId.COCIENTE,
    text: "data-lang-skformulaid-status6",
  },
];

export const enum__MessageStatus = {
  TOVISA: 5,
  SENDED: 4,
  ONAPROBATION: 3,
  ONCIRCULATION: 2,
  ONPRAPARATION: 1,
};

export const enum__Clients = {
  AMSA: "549E8991-29B1-4951-A24F-230F2FC0062A",
  BRECA: "82830C9E-A809-4452-B77C-8A3C920A1C50",
  DEFAULT: "default",
};

export const enum__MasterKPIStatusId = {
  VIGENTE: 1,
  AUTOMATICO_CONTRACTUAL: 2,
  INACTIVO: 3,
};
export const __MasterKPIStatusId = [
  {
    key: enum__MasterKPIStatusId.VIGENTE,
    text: "data-lang-skmasterkpistatus-status1",
    title: "data-lang-skmasterkpistatus-status1",
  },
  {
    key: enum__MasterKPIStatusId.AUTOMATICO_CONTRACTUAL,
    text: "data-lang-skmasterkpistatus-status2",
    title: "data-lang-skmasterkpistatus-status2",
  },
  {
    key: enum__MasterKPIStatusId.INACTIVO,
    text: "data-lang-skmasterkpistatus-status3",
    title: "data-lang-skmasterkpistatus-status3",
  },
];

export const enum__ConsolidationLeters = {
  Empty: 0,
  D: 1,
  R: 2,
};
export const __ConsolidationLeters = [
  {
    key: enum__ConsolidationLeters.D,
    text: "data-lang-lbl-d",
    letter: "data-lang-lbl-d-short",
  },
  {
    key: enum__ConsolidationLeters.R,
    text: "data-lang-lbl-r",
    letter: "data-lang-lbl-r-short",
  },
  {
    key: enum__ConsolidationLeters.Empty,
    text: "data-lang-lbl-nothing",
    letter: "--",
  },
];

export const enum__Consolidation = {
  Empty: "",
  D: "D",
  R: "R",
};
export const __Consolidation = [
  {
    id: enum__ConsolidationLeters.D,
    key: enum__Consolidation.D,
    text: "data-lang-lbl-d",
    letter: "data-lang-lbl-d-short",
  },
  {
    id: enum__ConsolidationLeters.R,
    key: enum__Consolidation.R,
    text: "data-lang-lbl-r",
    letter: "data-lang-lbl-r-short",
  },
  {
    id: enum__ConsolidationLeters.Empty,
    key: enum__Consolidation.Empty,
    text: "data-lang-lbl-nothing",
    letter: "data-lang-lbl-nothing",
  },
];

export const enum__BoardEventColor = {
  PURPLE: 1,
  BLUE: 2,
  OTHER: -1,
};
export const __BoardEventColor = [
  { key: enum__BoardEventColor.PURPLE, text: "purple" },
  { key: enum__BoardEventColor.BLUE, text: "blue" },
  { key: enum__BoardEventColor.OTHER, text: "grey" },
];

export const enum__GapColors = {
  PURPLE: "purple",
  RED: "red",
  GREEN: "green",
  BLUE: "blue",
  YELLOW: "yellow",
};

export const __GapColors = [
  { key: enum__GapColors.PURPLE, text: "#800080" },
  { key: enum__GapColors.RED, text: "#FF0000" },
  { key: enum__GapColors.GREEN, text: "#008000" },
  { key: enum__GapColors.BLUE, text: "#1F7BE8" },
  { key: enum__GapColors.YELLOW, text: "#ECA700" },
];

export const __GapEventTypes = {
  GAP_REVISION_ASSISTANTS: "gaprevisionassistants",
  GAP_REVISION_COMMENTS: "gaprevision",
  GAP_DATASERIEVALUE_COMMENTS: "dataserievalue",
  GAP_ACTION: "gapaction",
};
export const enum__GapActionTypes = {
  GAP_CAUSE: "gapcause",
  GAP_REVISION: "gaprevision",
};

export const enum__BoardCalendarFilter = {
  THIS_WEEK: 1,
  LAST_WEEK: 2,
  THIS_MONTH: 3,
  LAST_MONTH: 4,
  THIS_QUARTER: 5,
  LAST_QUARTER: 6,
  THIS_YEAR: 7,
  LAST_YEAR: 8,
  FIXED_MONTH: 9,
};

export const enum__BoardCalendarFilterDisplayFormat = {
  week: 1,
  month: 2,
  year: 3,
  range: 4,
};

export const __BoardCalendarFilter = [
  {
    key: enum__BoardCalendarFilter.THIS_WEEK,
    displayDateFormat: enum__BoardCalendarFilterDisplayFormat.week,
    text: "data-lang-lbl-thisweek",
  },
  {
    key: enum__BoardCalendarFilter.LAST_WEEK,
    displayDateFormat: enum__BoardCalendarFilterDisplayFormat.week,
    text: "data-lang-lbl-lastweek",
  },
  {
    key: enum__BoardCalendarFilter.THIS_MONTH,
    displayDateFormat: enum__BoardCalendarFilterDisplayFormat.month,
    text: "data-lang-lbl-thismonth",
  },
  {
    key: enum__BoardCalendarFilter.LAST_MONTH,
    displayDateFormat: enum__BoardCalendarFilterDisplayFormat.month,
    text: "data-lang-lbl-lastmonth",
  },
  {
    key: enum__BoardCalendarFilter.THIS_QUARTER,
    displayDateFormat: enum__BoardCalendarFilterDisplayFormat.range,
    text: "data-lang-lbl-thisquarter",
  },
  {
    key: enum__BoardCalendarFilter.LAST_QUARTER,
    displayDateFormat: enum__BoardCalendarFilterDisplayFormat.range,
    text: "data-lang-lbl-lastquerter",
  },
  {
    key: enum__BoardCalendarFilter.THIS_YEAR,
    displayDateFormat: enum__BoardCalendarFilterDisplayFormat.year,
    text: "data-lang-lbl-thisyear",
  },
  {
    key: enum__BoardCalendarFilter.LAST_YEAR,
    displayDateFormat: enum__BoardCalendarFilterDisplayFormat.year,
    text: "data-lang-lbl-lastyear",
  },
  {
    key: enum__BoardCalendarFilter.FIXED_MONTH,
    displayDateFormat: enum__BoardCalendarFilterDisplayFormat.range,
    text: "data-lang-lbl-fixedmonth",
  },
];

export const __enum_ChartDataserieInputType = {
  SINGLE: 1,
  MULTIPLE: 2,
};

export const enum__KPIAgregationTypes = {
  NO_AGG: 1,
  DF_AGG: 2,
};

export const enum___KPIAgregationTime = {
  SUM: 1,
  AVG: 2,
};

export const __MessageTypes = {
  ERROR: "error",
  WARNING: "warning",
  SUCCESS: "success",
  INFO: "info",
};

export const enum__CONTRACT_MODALITY = {
  CONTRACT_MODIFICATION: 1,
  ADJUSTMENT_CONTRACT_INCORPORATION: 2,
  ITEM_CONFIGURATION_CORRECTION: 3,
};

export const __CONTRACT_MODALITY = [
  {
    key: enum__CONTRACT_MODALITY.CONTRACT_MODIFICATION,
    name: "1.Modificación Contractual",
  },
  {
    key: enum__CONTRACT_MODALITY.ADJUSTMENT_CONTRACT_INCORPORATION,
    name: "2.Incorporación de Reajuste a contrato",
  },
  {
    key: enum__CONTRACT_MODALITY.ITEM_CONFIGURATION_CORRECTION,
    name: "3.Corrección configuración de partidas EP",
  },
];

export const __APIResponseMessageTypes = {
  ERROR: "data-lang-msg-operationerror",
  SUCCESS: "data-lang-msg-operationperformed",
};

export const enum__ElementType = {
  DATASERIE: 1,
  REVISION: 2,
};

export const __HeaderImageStyles = [
  {
    backgroundImage: `url('${headerWebSite1}')`,
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    height: "230px",
    width: "100%",
    backgroundPosition: "50% 50%",
    zIndex: "-100",
  },
  {
    backgroundImage: `url('${headerWebSite2}')`,
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    height: "230px",
    width: "100%",
    backgroundPosition: "50% 50%",
    zIndex: "-100",
  },
  {
    backgroundImage: `url('${headerWebSite3}')`,
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    height: "230px",
    width: "100%",
    backgroundPosition: "50% 50%",
    zIndex: "-100",
  },
  {
    backgroundImage: `url('${headerWebSite4}')`,
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    height: "230px",
    width: "100%",
    backgroundPosition: "50% 50%",
    zIndex: "-100",
  },
  {
    backgroundImage: `url('${headerWebSite5}')`,
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    height: "230px",
    width: "100%",
    backgroundPosition: "50% 50%",
    zIndex: "-100",
  },
  {
    backgroundImage: `url('${headerWebSite6}')`,
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    height: "230px",
    width: "100%",
    backgroundPosition: "50% 50%",
    zIndex: "-100",
  },
  {
    backgroundImage: `url('${headerWebSite7}')`,
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    height: "230px",
    width: "100%",
    backgroundPosition: "50% 50%",
    zIndex: "-100",
  },
  {
    backgroundImage: `url('${headerWebSite8}')`,
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    height: "230px",
    width: "100%",
    backgroundPosition: "50% 50%",
    zIndex: "-100",
  },
];

////PAY
export const enum__ENUM_CLASE_PARTIDA = {
  /// C1. Partidas de Servicios pagados a Suma Alzada.
  PSP_SUMA_ALZADA: 1,

  /// C2. Partidas de Servicios pagados a Precios Unitarios.
  PSP_PRECIO_UNITARIO: 2,

  /// C3. Partidas de Servicios pagados según consumo de Recursos.
  PSP_CONSUMO_RECURSOS: 3,

  /// C4. Partidas de Costos Indirectos pagados a Suma Alzada.
  PCI_SUMA_ALZADA: 4,

  /// C5. Partidas de Costos Indirectos pagados según consumo de Recursos.
  PCI_CONSUMO_RECURSOS: 5,

  /// R1. Recursos valorados a Suma Alzada.
  SRP_SUMA_ALZADA: 6,

  /// R2. Recursos valorados a Precios Unitarios.
  SRP_PRECIO_UNITARIO: 7,
};

export const enum_ENUM_CLASES_PARTIDA_TIPO_CLASE = {
  SERVICIO: 1,
  COSTO: 2,
  RECURSO: 3,
};

export const enum_CONTRACT_PARTIE_SIDEPANELS_CONFIG = {
  IS_OPEN_PARTIE_INSERT: 1,
  IS_OPEN_PARTIE_VIEW: 2,
  IS_OPEN_PARTIE_EDIT: 3,
  IS_OPEN_SUBPARTIE_INSERT: 4,
  IS_OPEN_SUBPARTIE_VIEW: 5,
  IS_OPEN_SUBPARTIE_EDIT: 6,

  IS_OPEN_PARTIE_FINISH: 7,
};

export const enum_EDPCONFIG_PARTIE_GROUP_MODE = {
  INSERT: 1,
  EDIT: 2,
};

export const enum_CONTACTPARTIE_PARTIE_FORM_VIEW = {
  INSERT: 1,
  EDIT: 2,
};

export const enum_CONTACTPARTIE_SUBPARTIE_FORM_VIEW = {
  INSERT: 1,
  EDIT: 2,
};

export const enum_CONTACTPARTIE_POLINOMY_FORM_VIEW = {
  SIMPLE_VIEW: 1,
  COMPLEX_EDIT: 2,
  COMPLEX_VEW: 3,
};

export const enum_CONTRACTPARTIE_PARENT_PONINOMY_TYPE = {
  PARTIE: 1,
  SUBPARTIE: 2,
};

export const enum_CONTRACTPARTIE_FORM_MODE = {
  CREATE: 1,
  VIEW: 2,
};

export const enum_EDPPREPARE_FORM_MODE = {
  CREATE: 1,
  VIEW: 2,
};

export const enum_TIPO_DI = {
  INCREMENTOS: 1,
  DEDUCCIONES: 2,
};

export const enum_ADJUSTMENT_CALCULATION_TYPE = {
  ADJUSTMENT_FACTOR: 1,
  ADJUSTMENT_AMOUNT: 2,
};

export const enum_ENUM_ESTADO_EP = {
  PREPARACION: 1,
  PREPARACION_SIMULADO: 2,
  APROBADO: 3,
  ANULADO: 4,
  HISTORICO: 5,
};

export const enum_ENUM_TIPO_ROLES_SEGURIDAD = {
  ADN: 1,
  ADN_SUPLENTE: 2,
  AEC: 3,
  AEC_SUPLENTE: 4,
  RFA: 5,
  USU: 6,
  GCO: 7,
  ATO: 8,
  AAD: 9,
  AHS: 10,
  AMA: 11,
  AGC: 12,
  AGP: 13,
  ALE: 14,
};

export const enum_ENUM_FLUJO_EP = {
  PREPARACION: 1,
  RECHAZADO: 2,
  ANULADO: 3,
  REVISION: 4,
  ABROPACION_ADN: 5,
  ABROPACION_RFA1: 6,
  ABROPACION_RFA2: 7,
  ABROPACION_RFA3: 8,
  APROBADO: 9,
  APROBADO_COMUNICADO: 10,
  HISTORICO: 11,
};

export const enum_ENUM_TIPO_RESPUESTA = {
  NINGUNO: 0, //Este no es aceptado en la tabla TIPO_RESPUESTA, solo es usado en el código.
  AEC: 1,
  ATO: 2,
  AAD: 3,
  ADN: 4,
  RFA1: 5,
  RFA2: 6,
  RFA3: 7,
  ICC: 8,
  LCC: 9,
};

export const __EdP_Config_RolResponsableIngreso = [
  { key: -1, text: "Seleccionar" },
  { key: enum_ENUM_TIPO_RESPUESTA.AAD, text: "AAD" },
  { key: enum_ENUM_TIPO_RESPUESTA.AEC, text: "AEC" },
];

export const enum_ENUM_ICONO_REVISION = {
  VALOR_ZERO_DI: -2,
  VALOR_ZERO_PARTIE: -1,
  SIN_REVISAR: 0,
  APROBADO: 1,
  RECHAZADO: 2,
  DESHABILITADO_SIN_REVISAR: 3,
  DESHABILITADO_APROBADO: 4,
  DESHABILITADO_RECHAZADO: 5,
  NINGUNO: 6,
  APROBADO_REVISAR: 7,
  DESHABILITADO_APROBADO_REVISAR: 8,
};

export const enum_ENUM_dIcono_Revision = [
  {
    key: enum_ENUM_ICONO_REVISION.VALOR_ZERO_PARTIE,
    value: "button-zero-partie-azul",
  },
  { key: enum_ENUM_ICONO_REVISION.VALOR_ZERO_DI, value: "button-zero-di-azul" },
  { key: enum_ENUM_ICONO_REVISION.SIN_REVISAR, value: "button-exclamacion" },
  { key: enum_ENUM_ICONO_REVISION.APROBADO, value: "button-aprobado" },
  {
    key: enum_ENUM_ICONO_REVISION.APROBADO_REVISAR,
    value: "button-aprobado-revisar",
  },
  { key: enum_ENUM_ICONO_REVISION.RECHAZADO, value: "button-rechazo" },
  {
    key: enum_ENUM_ICONO_REVISION.DESHABILITADO_SIN_REVISAR,
    value: "button-exclamacion-deshabilitado",
  },
  {
    key: enum_ENUM_ICONO_REVISION.DESHABILITADO_APROBADO,
    value: "button-aprobado-deshabilitado",
  },
  {
    key: enum_ENUM_ICONO_REVISION.DESHABILITADO_APROBADO_REVISAR,
    value: "button-aprobado-deshabilitado-revisar",
  },
  {
    key: enum_ENUM_ICONO_REVISION.DESHABILITADO_RECHAZADO,
    value: "button-rechazo-deshabilitado",
  },
];

export const __PartyAgrupationsPosition = [
  { id: 1, position: "I" },
  { id: 2, position: "II" },
  { id: 3, position: "III" },
  { id: 4, position: "IV" },
  { id: 5, position: "V" },
];

export const enum_elementContractEdPPartidasGraph = {
  GastoMensual: 1,
  EdPPresupuesto: 2,

  GastoAcum: 3,
  ProyeccionAcum: 4,
  ConsumoLineal: 5,
};

export const enum__NOTIFICATION_TYPE = {
  ANNOUNCEMENT: 1,
  TASK: 2,
  ANNOUNCEMENT_ROLE: 3,
  TASK_ROLE: 4,
};

export const enum__NOTIFICATION_INBOX_TYPE = {
  UNREAD: 0,
  UNFULFILLED: 1,
  INBOX: 2,
  IMPORTANT: 3,
  COMPLETED: 4,
  PRODUCT_CO: 5,
};

export const ENUM_NOTIFICACION_CLASE_BANDEJA = {
  CONTRACTUAL: 1,
  KPI: 2,
  EDP: 3,
  BOOK: 4,
};

export const __NotificationTypesMenuTitles = [
  {
    key: enum__NOTIFICATION_INBOX_TYPE.UNREAD,
    position: 2,
    text: "data-lang-lbl-menuunread",
  },
  {
    key: enum__NOTIFICATION_INBOX_TYPE.UNFULFILLED,
    position: 4,
    text: "data-lang-lbl-menuunfulfilled",
  },
  {
    key: enum__NOTIFICATION_INBOX_TYPE.INBOX,
    position: 1,
    text: "data-lang-lbl-menuinbox",
  },
  {
    key: enum__NOTIFICATION_INBOX_TYPE.IMPORTANT,
    position: 3,
    text: "data-lang-lbl-menuimportant",
  },
  {
    key: enum__NOTIFICATION_INBOX_TYPE.COMPLETED,
    position: 5,
    text: "data-lang-lbl-menucompleted",
  },
];

export const enum__NOTIFICATION_CLASS = {
  CONTRACT_NEW: 1,
  CONTRACT_MODIFICATION: 2,
  CONTRACT_ROLES: 3,
  CONTRACT_ITEM_NEW: 4,
  CONTRACT_ITEM_UPDATE: 5,
  CONTRACT_ITEMS_CLOSED: 6,
  CONTRACT_ITEMS_OPENED: 7,
  BOOK_NEW: 8,
  BOOK_MODIFICATION: 9,
  BOOK_USER_MODIFICATION: 10,
  BOOK_MSG_DRAFT: 11,
  BOOK_MSG_PENDING_RESPONSE: 12,
  BOOK_MSG_SEND: 13,
  BOOK_MSG_CONFIRMED: 14,
  BOOK_MSG_COMMENT: 15,
  BOOK_MSG_ASSIGNED_ASSISTANT: 16,
  BOOK_MSG_PENDING_ASSSITANT_VALIDATION: 17,
  BOOK_MILESTONE_INIT: 18,
  BOOK_MILESTONE_INIT_PENDING: 19,
  BOOK_MILESTONE_END: 20,
  BOOK_CLOSED: 21,
  KPI_NEW: 22,
  KPI_UPDATE: 23,
  KPI_NEW_VALUE: 24,
  KPI_UPDATE_VALUE: 25,
  GAP_ANALYZE_NEW: 26,
  GAP_REVISION_NEW: 27,
  GAP_REVISION_STATUS: 28,
  GAP_ACTION_NEW: 29,
  GAP_ACTION_ENGAGED: 30,
  GAP_ACTION_COMPLETED: 31,
  EDP_CONFIGURATION: 32,
  EDP_NEW: 33,
  EDP_CALCULATED: 34,
  EDP_APPROVED: 35,
  EDP_REFUSED: 36,
  EDP_DELETED: 37,
  EDP_PROCESS_FLOW: 38,
  CO_EXPIRED: 39,
  CO_TO_EXPIRE: 40,
  CO_TO_ACHIEVE: 41,
  CO_TO_VALIDATE: 42,
  BOOK_MSG_VISA: 43,
  BOOK_MSG_VISA_TO_ACHIEVE: 44,
  BOOK_MSG_DRAFT_TO_DELETE: 45,
  BOOK_MSG_PENDING_RESPONSE_OVERDUE: 46,
};

export const enum__NOTIFICATION_CUMPLIMIENTO_ID = {
  CUMPLIDA: 1,
  EXIGIBLE: 2,
  POR_VENCER: 3,
  VENCIDA: 4,
};

export const enum__NOTIFICATION_VALIDACION_ID = {
  OK: 1,
  RECHAZADA: 2,
  PENDIENTE: 3,
  NOREQUIERE: 4,
};

export const __NotificationClass = [
  {
    key: enum__NOTIFICATION_CLASS.CONTRACT_NEW,
    text: "data-lang-lbl-contractnew",
  },
  {
    key: enum__NOTIFICATION_CLASS.CONTRACT_MODIFICATION,
    text: "data-lang-lbl-contractmodification",
  },
  {
    key: enum__NOTIFICATION_CLASS.CONTRACT_ROLES,
    text: "data-lang-lbl-contractroles",
  },
  {
    key: enum__NOTIFICATION_CLASS.CONTRACT_ITEM_NEW,
    text: "data-lang-lbl-contractitemnew",
  },
  {
    key: enum__NOTIFICATION_CLASS.CONTRACT_ITEM_UPDATE,
    text: "data-lang-lbl-contractitemupdate",
  },
  {
    key: enum__NOTIFICATION_CLASS.CONTRACT_ITEMS_CLOSED,
    text: "data-lang-lbl-contractitemsclosed",
  },
  {
    key: enum__NOTIFICATION_CLASS.CONTRACT_ITEMS_OPENED,
    text: "data-lang-lbl-contractitemsopened",
  },
  { key: enum__NOTIFICATION_CLASS.BOOK_NEW, text: "data-lang-lbl-booknew" },
  {
    key: enum__NOTIFICATION_CLASS.BOOK_MODIFICATION,
    text: "data-lang-lbl-bookmodification",
  },
  {
    key: enum__NOTIFICATION_CLASS.BOOK_USER_MODIFICATION,
    text: "data-lang-lbl-bookusermodification",
  },
  {
    key: enum__NOTIFICATION_CLASS.BOOK_MSG_DRAFT,
    text: "data-lang-lbl-bookmsgdraft",
  },
  {
    key: enum__NOTIFICATION_CLASS.BOOK_MSG_PENDING_RESPONSE,
    text: "data-lang-lbl-bookmsgpendingresponse",
  },
  {
    key: enum__NOTIFICATION_CLASS.BOOK_MSG_SEND,
    text: "data-lang-lbl-bookmsgsend",
  },
  {
    key: enum__NOTIFICATION_CLASS.BOOK_MSG_CONFIRMED,
    text: "data-lang-lbl-bookmsgconfirmed",
  },
  {
    key: enum__NOTIFICATION_CLASS.BOOK_MSG_COMMENT,
    text: "data-lang-lbl-bookmsgcomment",
  },
  {
    key: enum__NOTIFICATION_CLASS.BOOK_MSG_ASSIGNED_ASSISTANT,
    text: "data-lang-lbl-bookmsgasignedassistant",
  },
  {
    key: enum__NOTIFICATION_CLASS.BOOK_MSG_PENDING_ASSSITANT_VALIDATION,
    text: "data-lang-lbl-bookmsgpendingassistantvalidation",
  },
  {
    key: enum__NOTIFICATION_CLASS.BOOK_MILESTONE_INIT,
    text: "data-lang-lbl-bookmilestoneinit",
  },
  {
    key: enum__NOTIFICATION_CLASS.BOOK_MILESTONE_INIT_PENDING,
    text: "data-lang-lbl-bookmilestoneinitpending",
  },
  {
    key: enum__NOTIFICATION_CLASS.BOOK_MILESTONE_END,
    text: "data-lang-lbl-bookmilestoneend",
  },
  {
    key: enum__NOTIFICATION_CLASS.BOOK_CLOSED,
    text: "data-lang-lbl-bookclosed",
  },
  { key: enum__NOTIFICATION_CLASS.KPI_NEW, text: "data-lang-lbl-kpinew" },
  { key: enum__NOTIFICATION_CLASS.KPI_UPDATE, text: "data-lang-lbl-kpiupdate" },
  {
    key: enum__NOTIFICATION_CLASS.KPI_NEW_VALUE,
    text: "data-lang-lbl-kpinewvalue",
  },
  {
    key: enum__NOTIFICATION_CLASS.KPI_UPDATE_VALUE,
    text: "data-lang-lbl-kpiupdatevalue",
  },
  {
    key: enum__NOTIFICATION_CLASS.GAP_ANALYZE_NEW,
    text: "data-lang-lbl-gapanalyzenew",
  },
  {
    key: enum__NOTIFICATION_CLASS.GAP_REVISION_NEW,
    text: "data-lang-lbl-gaprevisionnew",
  },
  {
    key: enum__NOTIFICATION_CLASS.GAP_REVISION_STATUS,
    text: "data-lang-lbl-gaprevisionstatus",
  },
  {
    key: enum__NOTIFICATION_CLASS.GAP_ACTION_NEW,
    text: "data-lang-lbl-gapactionnew",
  },
  {
    key: enum__NOTIFICATION_CLASS.GAP_ACTION_ENGAGED,
    text: "data-lang-lbl-gapactionengaged",
  },
  {
    key: enum__NOTIFICATION_CLASS.GAP_ACTION_COMPLETED,
    text: "data-lang-lbl-gapactioncompleted",
  },
  {
    key: enum__NOTIFICATION_CLASS.EDP_CONFIGURATION,
    text: "data-lang-lbl-edpconfiguration",
  },
  { key: enum__NOTIFICATION_CLASS.EDP_NEW, text: "data-lang-lbl-edpnew" },
  {
    key: enum__NOTIFICATION_CLASS.EDP_CALCULATED,
    text: "data-lang-lbl-edpcalculated",
  },
  {
    key: enum__NOTIFICATION_CLASS.EDP_APPROVED,
    text: "data-lang-lbl-edpapproved",
  },
  {
    key: enum__NOTIFICATION_CLASS.EDP_REFUSED,
    text: "data-lang-lbl-edprefused",
  },
  {
    key: enum__NOTIFICATION_CLASS.EDP_DELETED,
    text: "data-lang-lbl-edpdeleted",
  },
  {
    key: enum__NOTIFICATION_CLASS.EDP_PROCESS_FLOW,
    text: "data-lang-lbl-edpprocessflow",
  },
  { key: enum__NOTIFICATION_CLASS.CO_EXPIRED, text: "data-lang-lbl-coexpired" },
  {
    key: enum__NOTIFICATION_CLASS.CO_TO_EXPIRE,
    text: "data-lang-lbl-cotoexpire",
  },
  {
    key: enum__NOTIFICATION_CLASS.CO_TO_ACHIEVE,
    text: "data-lang-lbl-cotoachieve",
  },
  {
    key: enum__NOTIFICATION_CLASS.CO_TO_VALIDATE,
    text: "data-lang-lbl-cotovalidate",
  },

  {
    key: enum__NOTIFICATION_CLASS.BOOK_MSG_VISA,
    text: "data-lang-lbl-bookmsgvisa",
  },
  {
    key: enum__NOTIFICATION_CLASS.BOOK_MSG_VISA_TO_ACHIEVE,
    text: "data-lang-lbl-bookmsgvisatoachieve",
  },
  {
    key: enum__NOTIFICATION_CLASS.BOOK_MSG_DRAFT_TO_DELETE,
    text: "data-lang-lbl-bookmsgdrafttodelete",
  },
  {
    key: enum__NOTIFICATION_CLASS.BOOK_MSG_PENDING_RESPONSE_OVERDUE,
    text: "data-lang-lbl-bookmsgpendingresponseoverdue",
  },
];

export const enum__DOCUMENT_TEACH_TYPE = {
  TEXT: 1,
  PDF: 2,
  WORD: 3,
  POWER_POINT: 4,
  OTHER: 5,
  VIDEO_MP4: 6,
  VIDEO_FLV: 7,
  VIDEO_AVI: 8,
};

export const __DocumentTeachType = [
  {
    key: enum__DOCUMENT_TEACH_TYPE.TEXT,
    extension: ".txt",
    icon: "TextDocument",
    text: "data-lang-lbl-textdocument",
  },
  {
    key: enum__DOCUMENT_TEACH_TYPE.PDF,
    extension: ".pdf",
    icon: "PDF",
    text: "data-lang-lbl-pdf",
  },
  {
    key: enum__DOCUMENT_TEACH_TYPE.WORD,
    extension: ".docx",
    icon: "WordDocument",
    text: "data-lang-lbl-word",
  },
  {
    key: enum__DOCUMENT_TEACH_TYPE.POWER_POINT,
    extension: ".pptx",
    icon: "PowerPointDocument",
    text: "data-lang-lbl-powerpoint",
  },
  {
    key: enum__DOCUMENT_TEACH_TYPE.OTHER,
    extension: "",
    icon: "Document",
    text: "data-lang-lbl-other",
  },
  {
    key: enum__DOCUMENT_TEACH_TYPE.VIDEO_MP4,
    extension: ".mp4",
    icon: "PhotoVideoMedia",
    text: "data-lang-lbl-video",
  },
  {
    key: enum__DOCUMENT_TEACH_TYPE.VIDEO_FLV,
    extension: ".flv",
    icon: "PhotoVideoMedia",
    text: "data-lang-lbl-video",
  },
  {
    key: enum__DOCUMENT_TEACH_TYPE.VIDEO_AVI,
    extension: ".avi",
    icon: "PhotoVideoMedia",
    text: "data-lang-lbl-video",
  },
];

export const enum_OBLIGATION_FORM_VIEW = {
  VIEW: 0,
  INSERT: 1,
  EDIT: 2,
};

export const enum__BOOK_SECTION_CLASS = {
  GENERAL: 1,
  APERTURA: 2,
  CIERRE: 3,
  EJECUCION: 6
};
